export const locationlocale = [
  {
    id: "0160796a-07f5-49c2-914d-5abd512ac135",
    name: {
      ar: "كيارا في داماك هيلز",
      ru: "Kiara at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "0200c7d4-b756-4d96-a212-59f974e3b785",
    name: {
      ar: "سكاي كرست كوليكشن",
      ru: "Skycrest Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "03d2c5b8-fb6f-4a84-8b0f-d08a778858d7",
    name: {
      ar: "إيلو 3",
      ru: "ELO 3",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "04a8c082-0725-445e-a275-fa6863ea3395",
    name: {
      ar: "ألتيتيود دي جريسوغونو",
      ru: "Altitude de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "07fcfb23-3e0a-48f7-acbc-491344efff39",
    name: {
      ar: "نيس",
      ru: "Ницца",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "095051f5-4f8c-4651-a4e6-acae0173de2b",
    name: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "CANAL HEIGHTS 2 de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "09b7dc94-e17c-4f51-9be2-6d32ef439cb6",
    name: {
      ar: "لايك فيو",
      ru: "Lake View",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "0ae0e55d-053b-4ff9-90c8-c53e8228cd23",
    name: {
      ar: "غولف جيت في داماك هيلز",
      ru: "Golf Gate в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "0df73bdc-a5d9-432b-927d-41f459d98724",
    name: {
      ar: "ذا ريزيدنسز في بزنس سنترال",
      ru: "The Residences at Business Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "0dfc9f21-cefa-4cab-8282-641182278b07",
    name: {
      ar: "ماجان",
      ru: "Majan",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "150741ea-9eb4-4d51-be16-abeebce9ba0a",
    name: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1834a737-4c29-401f-b226-65dc76dc61f5",
    name: {
      ar: "ناتورا",
      ru: "Natura",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "18fcbe48-5cee-4938-b65d-6ebb38a2aebf",
    name: {
      ar: "داماك هيلز 2 (أكويا أكسجين)",
      ru: "DAMAC Hills 2 (AKOYA OXYGEN)",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1ed3da6d-ea6d-4ca8-96b8-cd328d2b772f",
    name: {
      ar: "غولف فيتا في داماك هيلز",
      ru: "Golf Vita at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2294335f-9d6a-4818-9cf6-58e5c924b4f9",
    name: {
      ar: "ملروز استايتس",
      ru: "Melrose Estates at Damac Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "231ebab8-8c52-44a7-aa71-10c73d17cf0f",
    name: {
      ar: "داماك ريفرسايد",
      ru: "DAMAC Riverside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "23a5722e-5442-4ca2-8d5b-f03c471efe4d",
    name: {
      ar: "تينورا",
      ru: "Tenora",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "23d4f36b-9bed-4570-8da6-4cede5a3cc8a",
    name: {
      ar: "برج أيكون سيتي سي",
      ru: "AYKON City Tower C",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "2575f670-ad21-45e5-ad2f-2bae236861a7",
    name: {
      ar: "داماك تاورز من باراماونت هوتيلز آند ريزورتس",
      ru: "DAMAC Towers by Paramount Hotels And  Resorts Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "28b4ecde-700a-44e0-8853-ac219f9a2d3d",
    name: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "291b41a5-68ec-41d5-9e4f-e632a0d2ad68",
    name: {
      ar: "تاور 108",
      ru: "Tower 108",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "2aea7e3a-f6f2-40ac-b179-117cab90ece0",
    name: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "2b3558be-d2ef-4945-99b1-46bf74fc545d",
    name: {
      ar: "قطع أراضي كانفاس بريميوم في داماك هيلز",
      ru: "Участки премиум-класса Canvas в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2da9662b-3352-4d77-bdac-4bc1bfaf4232",
    name: {
      ar: "لاغو فيستا",
      ru: "Lago Vista",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "308b0a38-83aa-414b-8085-dd0a44c72431",
    name: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "310f2bf5-7670-4e87-86bd-19a6b1f7e245",
    name: {
      ar: "غولف جيت 2",
      ru: "Golf Gate 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "356d3340-c38d-458d-a65c-fcec5789f935",
    name: {
      ar: "فلل أفينسيا",
      ru: "Виллы Авенсия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3657260f-08b5-43a5-8263-9dfbe23b7388",
    name: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "3671eb11-7545-43d8-85ff-4b91d00efac2",
    name: {
      ar: "أبر كرست",
      ru: "Upper Crest",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "3689ecc4-c746-46bc-8565-044598978178",
    name: {
      ar: "فلل بريفيليج في داماك هيلز 2",
      ru: "Виллы Privilege в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "388f2f96-1113-428e-aed7-94a521d3aa78",
    name: {
      ar: "داماك بريز",
      ru: "DAMAC Breeze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "39c66cfd-8b6e-4ca4-aa63-fe6ffa9ae40f",
    name: {
      ar: "أمورا",
      ru: "Amora",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3e5daceb-ae64-4803-ba0a-df2fcd493335",
    name: {
      ar: "بيل إير في ترامب إستيتس",
      ru: "BelAir в Trump Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3ff64abe-7f35-4b16-911b-78ad6d185b5d",
    name: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "411ada91-af09-4328-9a74-dfa7f3a87ee4",
    name: {
      ar: "برج زاده",
      ru: "Zada Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "412af58a-6801-4144-aeb0-105576912476",
    name: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "42861811-5e17-4140-aead-e8a45b7f5045",
    name: {
      ar: "داماك ريفرسايد فيوز",
      ru: "Вид на реку DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "468a0e59-8003-48d0-9a45-33a22fc54d87",
    name: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "4b49f160-5c7d-4957-801f-da88ab224447",
    name: {
      ar: "فلل بريستيج في داماك هيلز 2",
      ru: "Престижные виллы в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4d55beea-a774-4f9f-b082-8016c1f2a4e1",
    name: {
      ar: "فولتا",
      ru: "VOLTA",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "4d807e6d-12f6-4197-9d05-c7dddeee99c1",
    name: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "4db7932e-2cf8-42e0-ac75-7f28573556a5",
    name: {
      ar: "صفا تو دي غريسوغونو",
      ru: "Safa Two de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "4dc2980d-148c-4e42-a3d9-154c848b3f01",
    name: {
      ar: "تاون هاوس في منطقة الجولف والحديقة",
      ru: "Таунхаусы на The Golf And The Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4ea8b757-cb86-4d23-9bfb-c64cc01291da",
    name: {
      ar: "لايك تيراس",
      ru: "Lake Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "4fb00ea1-dc4b-4063-8754-41d4a52f1bd2",
    name: {
      ar: "فلل بريميير في داماك هيلز 2",
      ru: "Виллы класса «Премьер» в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "503888ef-8f93-44d6-b8c2-f343db874a7d",
    name: {
      ar: "أوشن سكيب",
      ru: "Oceanscape",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "51dd2b35-16aa-4e22-9b0c-cf82c9e67aa3",
    name: {
      ar: "فيولت 4",
      ru: "Violet 4",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "52464dd9-5b68-411e-9bbc-0cfe6c017d01",
    name: {
      ar: "جزيرة المرجان",
      ru: "Остров Аль-Марджан",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "Ras Al Khaimah",
      ru: "Рас-эль-Хайма",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "52a79927-95b4-4c10-be14-76871c582592",
    name: {
      ar: "فلل داماك من باراماونت هوتيلز آند ريزورتس دبي",
      ru: "Виллы DAMAC от Paramount Hotels And Resorts Дубай",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "52d9f806-12e8-4998-93be-8868be8d3891",
    name: {
      ar: "ريفا ريزيدنسز",
      ru: "Резиденции Рева",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "569a2f25-0166-4b52-be7a-5732f36fd0d2",
    name: {
      ar: "داماك ماجستين",
      ru: "DAMAC Величество",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "57ba52c2-08d0-43d0-bb4a-4dce8272086d",
    name: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "58ec7826-7243-4585-aaaf-d116c7f84248",
    name: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "5b5f3015-7fd2-4482-b3d6-fe9157e98b6b",
    name: {
      ar: "فندق داماك هيلز 2 إيدج من روتانا",
      ru: "DAMAC Hills 2 Hotel Edge by Rotana",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5b8ba29c-8d5a-4d2e-91a9-707b5b4d8cba",
    name: {
      ar: "الشعاب المرجانية",
      ru: "Коралловый Риф",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "5dfd5a25-0b45-4723-829b-f7e05912f491",
    name: {
      ar: "المغرب – المرحلة الثانية",
      ru: "Morocco – Phase 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5e461c9a-5e86-489c-940a-44970136bc53",
    name: {
      ar: "منطقة البرج",
      ru: "Район Бурдж",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "5ece69a2-df04-43fc-ba27-e77091b92f3d",
    name: {
      ar: "ذا فارم هاوسز",
      ru: "The Farmhouses",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "60869a85-cf34-47ac-9cfb-be98b9d7c7a4",
    name: {
      ar: "إبيزا",
      ru: "Ibiza",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "60aa4571-7b5e-497b-8e32-30f6e0e95d53",
    name: {
      ar: "بايز إيدج",
      ru: "Bay’s Edge",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "640d32fc-45da-4ed8-8747-b9f2007eac25",
    name: {
      ar: "خليج مارينا",
      ru: "Марина Бэй",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "6526076d-a81e-44e2-9c85-c62d55c4c7d2",
    name: {
      ar: "بيفرلي هيلز درايف",
      ru: "Beverly Hills Drive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "66753706-c4f9-4dcf-ae15-4bfffaf7af02",
    name: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "66b307b5-30e7-47d4-a89e-f4355bdd8431",
    name: {
      ar: "داماك إكزكيوتف هايتس",
      ru: "DAMAC Executive Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "6767d942-c6c5-4c80-b3ce-80f48185f69e",
    name: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "6a0ce928-d1fd-4816-a3a2-6c45671a9d58",
    name: {
      ar: "كافالي إستيتس",
      ru: "Кавалли Эстейтс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6ac0a85a-a871-421d-b1b5-90e75f34258e",
    name: {
      ar: "لوريتو في داماك هيلز",
      ru: "Loreto at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6ac51d87-dc43-46de-8153-e18e185a3332",
    name: {
      ar: "أرجان",
      ru: "Арджан",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "6af28421-4a7d-403e-b70b-2ba7446f6e6e",
    name: {
      ar: "إيلو",
      ru: "ELO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6d83eab8-35b1-453e-9e2a-326efc211478",
    name: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "6f59299c-cb4a-4cca-b9b3-f85488b9a333",
    name: {
      ar: "Ras Al Khaimah",
      ru: "Рас-эль-Хайма",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "",
      ru: "",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "70293b1e-4c3c-4ebe-8098-681f6242e21b",
    name: {
      ar: "مارينا تيراس",
      ru: "Marina Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "70858ee9-157e-47f8-a087-c0aa3560fbe5",
    name: {
      ar: "فيرديس",
      ru: "Virdis",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "720bc1da-08c0-4cee-bd6e-916ddf18070b",
    name: {
      ar: "غالية",
      ru: "Галия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "73fbe16b-71a4-419a-b013-4b031870da1b",
    name: {
      ar: "داماك ميزون كور جاردان",
      ru: "DAMAC Maison Cour Jardin",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "7435484d-9813-4be8-a51c-6573b871c44d",
    name: {
      ar: "جولف تاون في داماك هيلز",
      ru: "Гольф-городок в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "75ac9bf0-14c9-4ff7-a641-98bb2171465a",
    name: {
      ar: "عقارات جميرا للغولف",
      ru: "Jumeirah Golf Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "770b1613-ef60-4ade-9596-1b1c1bb3cc93",
    name: {
      ar: "برج جولف جرينز 2ب",
      ru: "ГОЛЬФ-ГРИНС ТАУЭР 2Б",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "771aedb4-076e-4688-afd3-221d387abc6a",
    name: {
      ar: "برج الأمواج",
      ru: "Башня Волн",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "77676542-419a-4d86-8dfb-2b2e2e94e050",
    name: {
      ar: "إﻳﻤﻴﺮﻳﺘﺲ ﺟﺎردﻧﺰ",
      ru: "Emirates Gardens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "77c3defb-1024-40d3-8cb2-a5b3ed45c231",
    name: {
      ar: "شورلاين من داماك",
      ru: "Shoreline от DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "Ras Al Khaimah",
      ru: "Рас-эль-Хайма",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة المرجان",
      ru: "Остров Аль-Марджан",
    },
  },
  {
    id: "7b2ff649-c1c2-4292-96c6-38448896a332",
    name: {
      ar: "غرين بارك",
      ru: "Green Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "7e9e7ab9-f0a9-44ab-966d-fe70e3df1a13",
    name: {
      ar: "فندق راديسون دبي داماك هيلز",
      ru: "Radisson Дубай DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "7fcdecab-74dd-470d-8fc6-6d99774061cf",
    name: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "8072097d-2fff-4630-8c81-8dcc41bac7a3",
    name: {
      ar: "داماك هايتس",
      ru: "DAMAC Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "81cfdb40-8968-4329-a089-d42973400538",
    name: {
      ar: "مجموعة أوتوغراف",
      ru: "Autograph Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "82a7dde6-4d8d-46dd-859e-b6803296ee0a",
    name: {
      ar: "صفا جيت",
      ru: "Safa Gate",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "8455f775-09ae-484b-9553-923821b2ed9e",
    name: {
      ar: "داماك صن سيتي",
      ru: "DAMAC Sun City",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Sun City Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "84b7a160-6b97-4f16-9709-e9d32d7be931",
    name: {
      ar: "بارك جرينز - المرحلة الثانية",
      ru: "Парк Гринс - Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "86856395-0cbc-41d3-87a3-7e89e6e1950d",
    name: {
      ar: "داماك ريزيدنزيه",
      ru: "DAMAC Residenze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "882ce9bc-4674-49de-98d7-1315999836d0",
    name: {
      ar: "داماك ميزون كنال فيوز",
      ru: "DAMAC Maison Canal Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "88ca2019-1927-40d7-8644-7e30dfe19a93",
    name: {
      ar: "أبراج بارك",
      ru: "Парковые башни",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مركز دبي المالي العالمي",
      ru: "Дубайский международный финансовый центр",
    },
  },
  {
    id: "8975eae6-4124-4c8e-b04e-e933b39c81a4",
    name: {
      ar: "ماديسون ريزيدنسز",
      ru: "Madison Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ماجان",
      ru: "Majan",
    },
  },
  {
    id: "8d637471-3974-40c4-8912-e104aa1fb533",
    name: {
      ar: "دبي",
      ru: "Дубай",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "",
      ru: "",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "8d73fb1e-6746-4184-94b4-9dfa29fd8edd",
    name: {
      ar: "سمارت هايتس",
      ru: "Smart Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "8f136e7a-48b1-4d5a-bd91-cffde7dfc4e9",
    name: {
      ar: "داماك فوليو",
      ru: "DAMAC Voleo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "901dd428-a9a3-439b-af31-945274dcbc00",
    name: {
      ar: "ترامب إستيتس في داماك هيلز",
      ru: "Поместья Трампа в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "928563f3-b1ca-4dbf-896c-cfa657123204",
    name: {
      ar: "جيمز استايتس",
      ru: "Gems Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9b2c2123-7247-4d05-aa4a-d28b187b886b",
    name: {
      ar: "إليغانس تاور",
      ru: "Elegance Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "9bc7bed9-e7ea-4251-b87b-57ac33755f9d",
    name: {
      ar: "جرينوودز",
      ru: "Гринвудс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9c3089e8-ef56-4b32-b5c0-5a66290cdb75",
    name: {
      ar: "برج أيكون سيتي ب",
      ru: "AYKON City Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "9c5cd2fa-a8b4-454f-9981-6d07eb431ab1",
    name: {
      ar: "داماك بريفيه",
      ru: "DAMAC Prive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "a0a8ae58-26b2-48cf-8d93-bc3fb776db7b",
    name: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a4c39784-6883-4627-a5cd-3791532910a4",
    name: {
      ar: "يوتوبيا",
      ru: "утопия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a72fcedd-a507-4c8f-8e4a-cf785ec32981",
    name: {
      ar: "صفا تو دي غريسوغونو - البرج B",
      ru: "Safa Two de GRISOGONO - Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "a7e51439-74a5-4ce2-84a6-0ce51d09f1fe",
    name: {
      ar: "فيرونا - داماك هيلز 2",
      ru: "Верона - DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a85c5e89-9f70-46c1-a946-802ed91926c5",
    name: {
      ar: "سيلفر سبرينغز في داماك هيلز",
      ru: "Silver Springs в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "aaad478f-00fc-4cfb-9a2a-96a2a2830a6a",
    name: {
      ar: "برج ميرانو",
      ru: "Merano Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "abf433a4-3087-46bf-acf6-ec187b5cd570",
    name: {
      ar: "فلل بارك في داماك هيلز",
      ru: "Виллы Park в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ac650d06-5426-46a0-928b-fae26fdd5eac",
    name: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "ad6be8a6-aaa4-49cb-8dd2-bb1a9f42e44e",
    name: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "af159eeb-7a56-4d25-b5b0-240c759364b4",
    name: {
      ar: "فلل إتيرنو بريستيج في داماك هيلز 2",
      ru: "Виллы Eterno Prestige в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "af51d1bc-991d-4940-ae46-d876478aa416",
    name: {
      ar: "شيك تاور",
      ru: "Chic Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "b5525b29-51ae-4580-bd7f-29c0836e19eb",
    name: {
      ar: "إيلو 2",
      ru: "ELO 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b904cafd-301c-42a4-bee7-106157ae8b24",
    name: {
      ar: "كوستا برافا",
      ru: "Коста Брава",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ba640ff6-6e5f-40af-baef-78c50bcebcc9",
    name: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "bacdb646-3ce2-4728-b3f1-ab4eeba6aee3",
    name: {
      ar: "بزنس تاور",
      ru: "Business Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "bd1b954b-0b29-4fa5-8ece-22c4c42c2019",
    name: {
      ar: "داماك ميزون مول ستريت",
      ru: "DAMAC Maison Mall Street",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "be3a3ddd-c8d2-43c8-b515-df11db3790c5",
    name: {
      ar: "هاربر لايتس دي جريسوغونو",
      ru: "HARBOUR LIGHTS DE GRISOGONO GENEVE",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "c1a8a846-08d0-4f62-a618-277d7512dbaf",
    name: {
      ar: "أفانتي",
      ru: "Avanti",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "c2a4aa8f-e5bd-43a6-a464-601ca699522f",
    name: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "c9c0d15c-c636-46fb-8423-325f6f5b7fd9",
    name: {
      ar: "باراماونت تاور هوتيل آند ريزيدنسز دبي",
      ru: "DAMAC Paramount Tower Hotel And Residences Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "cae34241-5ffb-4b98-9160-1da8b3b68e38",
    name: {
      ar: "بورتفينو",
      ru: "Портофино",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "cb91d5db-805a-4add-a954-77ae03503cf3",
    name: {
      ar: "بارك سنترال",
      ru: "Park Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "منطقة البرج",
      ru: "Район Бурдж",
    },
  },
  {
    id: "cd1e4a08-1825-406f-8392-a92ef3e0acab",
    name: {
      ar: "فيرا ريزيدنسز",
      ru: "Резиденции Вера",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "ce11a7dd-9035-4652-9ab5-8983bb2d24c5",
    name: {
      ar: "جرين إيكرز في داماك هيلز",
      ru: "Green Acres в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d043d368-8bf8-423c-8367-d6dcc6824eb0",
    name: {
      ar: "لايك سايد",
      ru: "Lakeside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "d06d5600-98f8-451a-9850-a704fc4ab180",
    name: {
      ar: "مالطا",
      ru: "Malta",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d74af8d8-cc38-4cdb-8e0c-71b23a6ee5e4",
    name: {
      ar: "سانتوريني",
      ru: "Санторини",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d77e1d3f-282e-4c07-bfc2-5d9426db42b5",
    name: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d78d5519-12a8-4712-af22-2c19ad746459",
    name: {
      ar: "سيليستيا",
      ru: "Селестия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "d7f16965-9763-4288-9548-e0bd8daa9c36",
    name: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "d81e3b3c-4037-4a3a-989e-73efc1105cff",
    name: {
      ar: "ورد",
      ru: "Цветок",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d8221e33-b78f-4bc6-8507-bd200ec6ab41",
    name: {
      ar: "شقق أول سيزونز تراس",
      ru: "Апартаменты All Seasons Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d9447009-f8be-4394-8a19-3d44735be521",
    name: {
      ar: "بارك تاون في داماك هيلز",
      ru: "Парк Таун в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d9c1d3f7-9646-41ed-90b5-d968311e19d4",
    name: {
      ar: "فلل كاميليا",
      ru: "Camelia Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "dd8b4d13-bce4-4499-8073-5cd5833127a9",
    name: {
      ar: "مونت كارلو",
      ru: "Monte Carlo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "df3029dd-194c-489f-89de-ad3924399c62",
    name: {
      ar: "فلل فينيتو في داماك هيلز",
      ru: "Виллы Венето в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e0212b47-844b-41d2-a34f-069849fdcfc3",
    name: {
      ar: "داماك ميزون ديستنكشن",
      ru: "DAMAC Maison Distinction",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "e02a2101-2b35-4e7b-a2d4-5decf13b8e3d",
    name: {
      ar: "البندقية",
      ru: "Венеция",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e05bc148-aef3-494c-8047-c7476da6dbbe",
    name: {
      ar: "ذا ليجندز",
      ru: "The Legends",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e1e0f56e-e80b-4890-b611-ef8cd713ba80",
    name: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "e39cb2d1-7c50-4677-8429-c87bb3594bf2",
    name: {
      ar: "إيفرغرينز",
      ru: "Evergreens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e501d448-746d-43b5-aed8-23f4ef518086",
    name: {
      ar: "لينكولن بارك",
      ru: "Lincoln Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أرجان",
      ru: "Арджан",
    },
  },
  {
    id: "e6863a11-520c-4daa-9495-590959134670",
    name: {
      ar: "بوتيك فيلاز 90210",
      ru: "90210 Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e70b7922-c5c2-45b5-b5b0-85b42f15a80f",
    name: {
      ar: "مركز دبي المالي العالمي",
      ru: "Дубайский международный финансовый центр",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "e8c25c47-b587-455c-a8ed-3f9c6e9ac49a",
    name: {
      ar: "بيلفيستا في داماك هيلز",
      ru: "Беллависта в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ea8579d4-86ed-4fb8-90aa-a8734bfed634",
    name: {
      ar: "داماك سوبيربيا",
      ru: "DAMAC Suburbia",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
  },
  {
    id: "ef316330-fb7c-4332-a42e-466dd5052ecd",
    name: {
      ar: "حدائق عالية في داماك هيلز",
      ru: "Высокие сады в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ef761257-1b49-45b2-b4c7-0a7f5637d0ef",
    name: {
      ar: "أوشن هايتس",
      ru: "Ocean Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "f1bd0513-60b8-4ce7-a1c5-7e0ff8fea5c7",
    name: {
      ar: "إكزكتيف باي",
      ru: "Executive Bay",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f265b1f8-6c90-44f4-9912-816ddc1abc2a",
    name: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "f2f6e497-149e-4c75-b58e-212d00e12c7a",
    name: {
      ar: "ذا كريسنت",
      ru: "The Crescent",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "f35a3898-418d-4c60-a747-995fad5bb12c",
    name: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f37821ac-a1f0-4363-a6e4-58ebd87c3510",
    name: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "",
      ru: "",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "f3b69ce9-45c7-4673-933d-0e56e4dfedda",
    name: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f3e6df3d-2500-4a29-a5ac-6bc58734b8f7",
    name: {
      ar: "فلل رويال غولف بوتيك",
      ru: "Royal Golf Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "عقارات جميرا للغولف",
      ru: "Jumeirah Golf Estates",
    },
  },
  {
    id: "f53cc1ab-f138-41fe-86de-eb0a81b3a684",
    name: {
      ar: "برج إكس إل",
      ru: "XL Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f7fd3de0-8f51-4496-9ccc-44236c2d064c",
    name: {
      ar: "داماك آيلاندز",
      ru: "DAMAC Islands",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Islands Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f89ae18f-48c5-45c9-b4e8-5ed8fc78d3a8",
    name: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "fc17dbf9-435b-47ca-90f8-9b8292c90f99",
    name: {
      ar: "ميكونوس",
      ru: "Mykonos",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "fdeb754f-2af3-4c6c-a43d-4769886944a4",
    name: {
      ar: "برج كافالي",
      ru: "Башня Кавалли",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "ff2309fa-6cdb-462a-831c-350fd7c4595d",
    name: {
      ar: "توسكان ريزيدنسز",
      ru: "Tuscan Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "ff49ca92-b0d6-4022-b446-56c144ef9195",
    name: {
      ar: "ماربيّا",
      ru: "Marbella",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ffc6897c-09e2-4890-954c-150d978ba6f8",
    name: {
      ar: "بيل إير في ترامب إستيتس - المرحلة الثانية",
      ru: "BelAir в Trump Estates – Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "04f5a944-cdf4-41e8-be42-df1060d86e4c",
    name: {
      ar: "جرين إيكرز في داماك هيلز",
      ru: "Green Acres в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "07362268-1e71-4eab-bbb9-d2d7e0fc6ea8",
    name: {
      ar: "داماك هايتس",
      ru: "DAMAC Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "07a40524-1bfd-4614-af3a-ebac411c42dd",
    name: {
      ar: "إكزكتيف باي",
      ru: "Executive Bay",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "07aa7f1e-0873-4fc9-8515-88d9ace384bc",
    name: {
      ar: "أمورا",
      ru: "Amora",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "084bf96c-22d2-4456-911d-ba5c1f977de6",
    name: {
      ar: "جرينوودز",
      ru: "Гринвудс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "08e048f2-1895-4310-b2a3-59dc30ce6ad9",
    name: {
      ar: "بيل إير في ترامب إستيتس",
      ru: "BelAir в Trump Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "09aa1419-d686-4eb5-bad4-92ae46f98af9",
    name: {
      ar: "غرين بارك",
      ru: "Green Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "0b37fce8-234b-4032-b20b-677f05ea6730",
    name: {
      ar: "تاون هاوس في منطقة الجولف والحديقة",
      ru: "Таунхаусы на The Golf And The Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "0c09c213-1350-4d53-95e8-a4a898365867",
    name: {
      ar: "صفا تو دي غريسوغونو",
      ru: "Safa Two de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "0c113e0b-22c0-4237-af4c-2f4baaffcec7",
    name: {
      ar: "برج إكس إل",
      ru: "XL Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "0c51d488-7514-4bcf-a579-6eebed19a97c",
    name: {
      ar: "برج جولف جرينز 2ب",
      ru: "ГОЛЬФ-ГРИНС ТАУЭР 2Б",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "0eaa20b8-a758-466d-9946-92dfb5f1599f",
    name: {
      ar: "برج كافالي",
      ru: "Башня Кавалли",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "101b94c2-ede5-4921-8191-d8b476abff29",
    name: {
      ar: "ذا ليجندز",
      ru: "The Legends",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "135bd6e1-19a1-4225-ba24-cc73d6c91433",
    name: {
      ar: "ماجان",
      ru: "Majan",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "139e201d-6fb6-45ff-ab13-c8a6327fc17c",
    name: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "143bef97-c9dd-4b7f-81c1-3f76e0bccb97",
    name: {
      ar: "إيلو 3",
      ru: "ELO 3",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "15e46e18-dd46-46ca-b7a7-3a315f5a63c0",
    name: {
      ar: "بارك سنترال",
      ru: "Park Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "منطقة البرج",
      ru: "Район Бурдж",
    },
  },
  {
    id: "161bee0e-6c89-452a-b6e1-5c117a20cf79",
    name: {
      ar: "برج ميرانو",
      ru: "Merano Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "17326425-c3c0-48ba-839a-02652f77fa41",
    name: {
      ar: "هاربر لايتس دي جريسوغونو",
      ru: "HARBOUR LIGHTS DE GRISOGONO GENEVE",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "1798caab-b31f-4b36-8083-30be54d9118f",
    name: {
      ar: "ألتيتيود دي جريسوغونو",
      ru: "Altitude de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "1995b013-59ef-4fcb-abc7-23c229746c4d",
    name: {
      ar: "Ras Al Khaimah",
      ru: "Рас-эль-Хайма",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "",
      ru: "",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "1a48aca4-f8ad-45b8-b245-978aa84e6f0d",
    name: {
      ar: "توسكان ريزيدنسز",
      ru: "Tuscan Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "1d4fdf84-444d-4090-9354-4650460e370a",
    name: {
      ar: "تينورا",
      ru: "Tenora",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "1d52f689-a67b-402e-a9c9-f2e5ee0d9869",
    name: {
      ar: "ملروز استايتس",
      ru: "Melrose Estates at Damac Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1f2cd48a-84d3-45d7-a4de-7194dfdfba6a",
    name: {
      ar: "فلل فينيتو في داماك هيلز",
      ru: "Виллы Венето в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "21b700fd-e231-4d4e-9048-2f13f2cbbf44",
    name: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "233a0b90-acec-4ee2-9c07-39b9f4391e95",
    name: {
      ar: "فلل داماك من باراماونت هوتيلز آند ريزورتس دبي",
      ru: "Виллы DAMAC от Paramount Hotels And Resorts Дубай",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "268d978b-90b4-4681-acd2-e7c0ba7ebb26",
    name: {
      ar: "كوستا برافا",
      ru: "Коста Брава",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2b2ddec5-0e72-4d71-81b1-ad4fafaffddd",
    name: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "2bf21d2b-63af-4273-802d-de9223ab831d",
    name: {
      ar: "داماك بريفيه",
      ru: "DAMAC Prive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "2fe6ed40-e9d3-402c-9137-b7a3e3b7bd28",
    name: {
      ar: "صفا تو دي غريسوغونو - البرج B",
      ru: "Safa Two de GRISOGONO - Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "3030d14a-786e-488e-8d07-e56619c75d0c",
    name: {
      ar: "ذا فارم هاوسز",
      ru: "The Farmhouses",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "30998416-02f2-4826-a065-c24f43db9c6e",
    name: {
      ar: "داماك إكزكيوتف هايتس",
      ru: "DAMAC Executive Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "30c8e72c-5aad-4937-b725-0baa7cd7109f",
    name: {
      ar: "ماربيّا",
      ru: "Marbella",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "30dc77c4-d892-461c-8115-9a16caa81b7d",
    name: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "33259561-2cd9-4f58-93ce-7ee531256646",
    name: {
      ar: "ماديسون ريزيدنسز",
      ru: "Madison Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ماجان",
      ru: "Majan",
    },
  },
  {
    id: "341aa19d-ce80-4c30-9195-1666faa85c45",
    name: {
      ar: "فيرا ريزيدنسز",
      ru: "Резиденции Вера",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "38b4384a-9989-4a9f-ab86-cdfff3cd74b5",
    name: {
      ar: "داماك آيلاندز",
      ru: "DAMAC Islands",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Islands Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3a682311-0b88-471e-876b-7b796e72cbb6",
    name: {
      ar: "فيرديس",
      ru: "Virdis",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3d8ec8f9-5c45-4d3e-a3b5-e38d65a382a1",
    name: {
      ar: "داماك فوليو",
      ru: "DAMAC Voleo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "3e94f246-c8e5-4358-aad1-3a0eb07f7e2f",
    name: {
      ar: "ريفا ريزيدنسز",
      ru: "Резиденции Рева",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "450f5bd4-2774-457d-bb44-08d8b9692686",
    name: {
      ar: "أبر كرست",
      ru: "Upper Crest",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "457e7bb5-e625-4581-94ea-b56f2d06e3e2",
    name: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "4b3f7049-c950-4ef5-b903-a5f677d57387",
    name: {
      ar: "فلل كاميليا",
      ru: "Camelia Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4d40988b-0481-48f7-b700-b7a053e0f630",
    name: {
      ar: "البندقية",
      ru: "Венеция",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4d87aa58-0a6d-48da-aaf5-ad3bd66ef397",
    name: {
      ar: "كيارا في داماك هيلز",
      ru: "Kiara at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4f897633-b17b-4571-a685-f340459d7ef7",
    name: {
      ar: "مارينا تيراس",
      ru: "Marina Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "5093a8c6-671c-4489-a13a-8f3fee5ba396",
    name: {
      ar: "أوشن سكيب",
      ru: "Oceanscape",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "52f0a1e1-4edb-4ea1-940e-c846f1689cf5",
    name: {
      ar: "برج زاده",
      ru: "Zada Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "53012eb8-1b4f-4b67-8401-86aabea1d8c1",
    name: {
      ar: "داماك ميزون كور جاردان",
      ru: "Дворовый сад Majanа DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "53622941-590d-4dcd-bee8-bf7cb5a9f820",
    name: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "53af2e20-c1e7-4a43-8556-76f168459d5d",
    name: {
      ar: "شورلاين من داماك",
      ru: "Shoreline от DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "Ras Al Khaimah",
      ru: "Рас-эль-Хайма",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة المرجان",
      ru: "Остров Аль-Марджан",
    },
  },
  {
    id: "5492f102-ed8f-4234-b799-ca25d36b190a",
    name: {
      ar: "مركز دبي المالي العالمي",
      ru: "Дубайский международный финансовый центр",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "57adb9e2-d746-4740-9418-95d76fdb9bd2",
    name: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "5a3f62fe-a05e-4931-8c40-3dd6db5d869b",
    name: {
      ar: "غولف جيت في داماك هيلز",
      ru: "Golf Gate в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5b9d2875-e9f6-4c6a-8c9f-2d1a0f009c99",
    name: {
      ar: "بيلفيستا في داماك هيلز",
      ru: "Беллависта в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5c7f0416-5694-4bd0-8a8b-a3de5b0176d0",
    name: {
      ar: "كافالي إستيتس",
      ru: "Кавалли Эстейтс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "61566cde-5eed-4c63-af36-21054e47b8bf",
    name: {
      ar: "ذا كريسنت",
      ru: "The Crescent",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "6159417a-3813-43b6-aeea-c835b82d0719",
    name: {
      ar: "إيلو 2",
      ru: "ELO 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "61d8bff8-6da7-4dbd-8ef5-89c08bdfacf5",
    name: {
      ar: "الشعاب المرجانية",
      ru: "Коралловый Риф",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "63df1964-d44f-48b7-b373-b386fc86f004",
    name: {
      ar: "بارك تاون في داماك هيلز",
      ru: "Парк Таун в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "64b0c655-b793-4797-8464-8338eb8b696e",
    name: {
      ar: "منطقة البرج",
      ru: "Район Бурдж",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "655c7277-f1f3-4265-8f09-18783ab084ba",
    name: {
      ar: "لوريتو في داماك هيلز",
      ru: "Loreto at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6b0b9bcc-8e45-4c4a-bad1-3a4350e4f2fd",
    name: {
      ar: "أبراج بارك",
      ru: "Парковые башни",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مركز دبي المالي العالمي",
      ru: "Дубайский международный финансовый центр",
    },
  },
  {
    id: "6b9384db-f7ab-4009-8be9-a3ae4caefbe9",
    name: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "6bcb4b7b-634e-40e4-bc16-897676d3c0c3",
    name: {
      ar: "فلل بريفيليج في داماك هيلز 2",
      ru: "Виллы Privilege в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6c0e4e53-7aac-4456-a224-fdb86394a544",
    name: {
      ar: "داماك صن سيتي",
      ru: "DAMAC Sun City",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Sun City Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "758d09ef-c7b1-473d-99ea-ca2bcf9a077b",
    name: {
      ar: "داماك سوبيربيا",
      ru: "DAMAC Suburbia",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
  },
  {
    id: "76b35da5-feb4-4eca-b924-5cd72a3cb264",
    name: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "76c3281f-7d49-4987-a80b-1097b577386f",
    name: {
      ar: "باراماونت تاور هوتيل آند ريزيدنسز دبي",
      ru: "DAMAC Paramount Tower Hotel And Residences Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "77cd8bb8-e37f-4ec6-9b16-fa590dd956cf",
    name: {
      ar: "سيلفر سبرينغز في داماك هيلز",
      ru: "Silver Springs в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "79084f1d-55d5-4ae2-923b-203b39c91171",
    name: {
      ar: "تاور 108",
      ru: "Tower 108",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "7b3df116-b2e9-4ffe-827b-b73eb9d93cd8",
    name: {
      ar: "مونت كارلو",
      ru: "Monte Carlo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "7bff55d8-63f7-4e71-99a3-a9dfc1c64a94",
    name: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "7d9f8ed7-56de-4e4c-a300-43a99016ed7e",
    name: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "7fb282e8-6a24-47d4-a56f-6ae969acf901",
    name: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "82c1c41c-29b2-4507-bc5b-8d515a9c5d07",
    name: {
      ar: "غولف فيتا في داماك هيلز",
      ru: "Golf Vita at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "86fcdf62-5779-4837-ab10-ce14cc973f72",
    name: {
      ar: "جزيرة المرجان",
      ru: "Остров Аль-Марджан",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "Ras Al Khaimah",
      ru: "Рас-эль-Хайма",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "88cb225c-b442-425a-8d75-e5672c6f5100",
    name: {
      ar: "أفانتي",
      ru: "Avanti",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "8949a568-50ea-4cde-a9f3-3fa25fdf066b",
    name: {
      ar: "داماك ريزيدنزيه",
      ru: "DAMAC Residenze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "89a26938-38b6-4268-bf47-8af3c1acef5e",
    name: {
      ar: "حدائق عالية في داماك هيلز",
      ru: "Высокие сады в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "8babeb4a-fca3-4d79-ae84-7732b52c733d",
    name: {
      ar: "فندق داماك هيلز 2 إيدج من روتانا",
      ru: "DAMAC Hills 2 Hotel Edge by Rotana",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "8c31fb28-6f22-4eb9-a4c0-916279d217a5",
    name: {
      ar: "جولف تاون في داماك هيلز",
      ru: "Гольф-городок в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "8db6b9bb-ea3d-407b-9b4f-cda92d573217",
    name: {
      ar: "داماك تاورز من باراماونت هوتيلز آند ريزورتس",
      ru: "DAMAC Towers by Paramount Hotels And  Resorts Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "8dc6d9be-57a7-4496-bf86-d7d6e4dec526",
    name: {
      ar: "بارك جرينز - المرحلة الثانية",
      ru: "Парк Гринс - Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "8ff2f75e-73b7-4355-b031-99c6f8f6eb66",
    name: {
      ar: "لينكولن بارك",
      ru: "Lincoln Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أرجان",
      ru: "Арджан",
    },
  },
  {
    id: "906e2593-64e9-453a-8e94-c41e57ee39b1",
    name: {
      ar: "يوتوبيا",
      ru: "утопия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "92b6cadd-f479-4115-b1f6-e8038a97028d",
    name: {
      ar: "صفا جيت",
      ru: "Safa Gate",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "93405e2e-ff9e-4640-921a-9922aef08c35",
    name: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "93ece6d6-e3ee-40d2-9f7d-1ae8d307e7a7",
    name: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "95ee967c-e0ef-4ac8-a86b-dd87cdd59855",
    name: {
      ar: "داماك ميزون كنال فيوز",
      ru: "DAMAC Maison Canal Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "963dea88-027a-46a2-971a-d3e80fc8241b",
    name: {
      ar: "بيفرلي هيلز درايف",
      ru: "Beverly Hills Drive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "967fbad5-3979-4d90-85d0-f0b6b66b85af",
    name: {
      ar: "ميكونوس",
      ru: "Mykonos",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "97a23fa6-3691-4648-97c7-48d014bff711",
    name: {
      ar: "ورد",
      ru: "Цветок",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "981108bd-92ed-4068-a0e7-31ce4565004c",
    name: {
      ar: "بايز إيدج",
      ru: "Bay’s Edge",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "9952c682-e014-4667-a5c2-cbcb1ccae512",
    name: {
      ar: "فندق راديسون دبي داماك هيلز",
      ru: "Radisson Дубай DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9995e734-4c27-4324-9508-aa8efa8cb45d",
    name: {
      ar: "داماك ريفرسايد فيوز",
      ru: "Вид на реку DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "99e3ec05-8e38-432f-a3ad-6714f2b5fb76",
    name: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "9ceadd27-7372-49ad-b048-0e35aeeefe0f",
    name: {
      ar: "شيك تاور",
      ru: "Chic Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "9d61ad46-d81c-4f44-a989-7018af19b38e",
    name: {
      ar: "المغرب – المرحلة الثانية",
      ru: "Morocco – Phase 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9f4ee35f-48ad-4377-9946-932aa64392ab",
    name: {
      ar: "فلل إتيرنو بريستيج في داماك هيلز 2",
      ru: "Виллы Eterno Prestige в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9f84b6c7-5064-414e-b0aa-33e40b6fbbc0",
    name: {
      ar: "دبي",
      ru: "Дубай",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "",
      ru: "",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "a05da3b4-cb5a-458e-8864-acc5399c31a9",
    name: {
      ar: "أرجان",
      ru: "Арджан",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "a2d0bb84-5c8d-48a7-9e5a-1bb0a12a4e4f",
    name: {
      ar: "ذا ريزيدنسز في بزنس سنترال",
      ru: "The Residences at Business Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "a3394700-4e8f-4c43-978d-95e3f2e65bd3",
    name: {
      ar: "فيرونا - داماك هيلز 2",
      ru: "Верона - DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a34b366b-b751-46b8-8473-d21b1f143194",
    name: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "",
      ru: "",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "a7abd33b-cfc3-409a-a52f-786ed094f93a",
    name: {
      ar: "مجموعة أوتوغراف",
      ru: "Autograph Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a814e7d2-3044-4716-8753-52458b248562",
    name: {
      ar: "سكاي كرست كوليكشن",
      ru: "Skycrest Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "a8cdac4c-72fb-4c2e-b646-2b99f1d1aa8e",
    name: {
      ar: "إليغانس تاور",
      ru: "Elegance Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "aa78ab1d-8b38-46d7-9203-6d8d90b55b33",
    name: {
      ar: "قطع أراضي كانفاس بريميوم في داماك هيلز",
      ru: "Участки премиум-класса Canvas в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ac5a228c-141b-4556-9f31-df9f288f8f3d",
    name: {
      ar: "فيولت 4",
      ru: "Violet 4",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "adbda08d-7b1b-4c3f-9ed5-5e93cadaa9d3",
    name: {
      ar: "بزنس تاور",
      ru: "Business Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "b2cd54a1-db99-4db2-b3bc-f585cf9e77af",
    name: {
      ar: "سمارت هايتس",
      ru: "Smart Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "b44d4df5-01cf-4c73-856b-5562a8494706",
    name: {
      ar: "ناتورا",
      ru: "Natura",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b6862f9b-9f14-48a7-8829-d3d93a77baef",
    name: {
      ar: "فلل أفينسيا",
      ru: "Виллы Авенсия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b7449c4d-3650-4d14-8db1-64900933a207",
    name: {
      ar: "داماك ريفرسايد",
      ru: "DAMAC Riverside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "b782fedb-6b6c-41b5-8916-4da0365b51fa",
    name: {
      ar: "وقت",
      ru: "VOLTA",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "b96ff5d8-145d-4bcf-803d-6ee18bce5adb",
    name: {
      ar: "بوتيك فيلاز 90210",
      ru: "90210 Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "bac778ae-2efa-4a7b-a0b1-415736f244ee",
    name: {
      ar: "غالية",
      ru: "Галия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "bbdac293-b615-452c-9368-36484d392f02",
    name: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "bde22b50-d826-409f-80e1-c4e847c5d9f4",
    name: {
      ar: "فلل بريميير في داماك هيلز 2",
      ru: "Виллы класса «Премьер» в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c065fa53-0535-4395-8a27-13d7456cd923",
    name: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "c2a41458-89f4-4d1e-8e9e-abc30fc4d2e0",
    name: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c351b4f8-a618-4fa8-94c5-1a0463a7c1c6",
    name: {
      ar: "فلل بارك في داماك هيلز",
      ru: "Виллы Park в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c37b057c-f3e1-4c2f-a3fb-b174952363d1",
    name: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c44e60b7-9745-4ddc-82c4-c6ee11852eef",
    name: {
      ar: "إيفرغرينز",
      ru: "Evergreens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c4d10bfa-04d8-4931-9c83-f02cc4810072",
    name: {
      ar: "ترامب إستيتس في داماك هيلز",
      ru: "Trump Estates в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c5182502-15ac-4ff0-9ed1-b5b8d38d9eca",
    name: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "c5e32556-1cd9-4bd3-b924-cf1b5a7265dd",
    name: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "c81da233-583d-41ce-9f7f-c66a83d08f6f",
    name: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "c8edf204-8d80-46bd-a0dd-1ffc4112db8a",
    name: {
      ar: "داماك هيلز 2 (أكويا أكسجين)",
      ru: "DAMAC Hills 2 (AKOYA OXYGEN)",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c92a009d-aad4-4f53-9523-5509ae9b3137",
    name: {
      ar: "داماك ماجستين",
      ru: "DAMAC Majestine",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "cb56f750-0193-4a71-bb82-bbf5c62689cf",
    name: {
      ar: "لايك تيراس",
      ru: "Lake Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "cb60cd0f-2eba-43ab-9aab-83e7d7e9fa70",
    name: {
      ar: "بيل إير في ترامب إستيتس - المرحلة الثانية",
      ru: "BelAir в Trump Estates – Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "cd0b60a7-2149-4478-ab20-ec58ef5618bb",
    name: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "cf603949-4e7e-41ae-a3cf-30418256b0ac",
    name: {
      ar: "داماك بريز",
      ru: "DAMAC Breeze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "cf64f9b8-e6b8-4ff7-86b8-75a360591118",
    name: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "d01bd3b7-d8ab-41f0-b2ab-b289cfa00ad4",
    name: {
      ar: "أوشن هايتس",
      ru: "Ocean Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "d1147d29-a354-449d-afbd-d47fc730dffe",
    name: {
      ar: "لايك فيو",
      ru: "Lake View",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "d688e43e-3804-4650-97b6-a5974ee82b9d",
    name: {
      ar: "عقارات جميرا للغولف",
      ru: "Jumeirah Golf Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "d71f7282-29d6-4f24-9ed9-bd27ec654d1a",
    name: {
      ar: "غولف جيت 2",
      ru: "Golf Gate 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d8c6684e-26bd-4b8c-9a3d-0db19b6b18e0",
    name: {
      ar: "لاغو فيستا",
      ru: "Lago Vista",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "da48b7d0-5b70-4c2b-96db-b0e1a1ab3331",
    name: {
      ar: "فلل رويال غولف بوتيك",
      ru: "Royal Golf Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "عقارات جميرا للغولف",
      ru: "Jumeirah Golf Estates",
    },
  },
  {
    id: "daa87e1b-d7b2-4dbc-a7fb-6875f3b81cd9",
    name: {
      ar: "لايك سايد",
      ru: "Lakeside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "db8d0e1e-2205-49d2-b250-cb9be39f7a3d",
    name: {
      ar: "برج أيكون سيتي ب",
      ru: "AYKON City Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "dbb198bd-ac0d-444d-9232-e29528d38637",
    name: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "dc2fb6a1-53ec-4cc9-bdd7-cea0bbddd3dc",
    name: {
      ar: "نيس",
      ru: "Ницца",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "dda231e2-9e14-49a3-a9d3-d518adf2fa47",
    name: {
      ar: "إبيزا",
      ru: "Ibiza",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "df49299b-a936-43f3-a70a-72e5d76507d4",
    name: {
      ar: "داماك ميزون ديستنكشن",
      ru: "DAMAC Maison Distinction",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "e1a9d900-f149-4d6f-8def-3e326d28bbe0",
    name: {
      ar: "فلل بريستيج في داماك هيلز 2",
      ru: "Престижные виллы в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e293b125-22e9-44e2-88c2-2fb5d683071d",
    name: {
      ar: "بورتوفينو",
      ru: "Портофино",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e3e5495b-c430-412e-852c-cf8721425bca",
    name: {
      ar: "إيلو",
      ru: "ELO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ea360010-1206-47a9-95c7-4159c1dc8aff",
    name: {
      ar: "إﻳﻤﻴﺮﻳﺘﺲ ﺟﺎردﻧﺰ",
      ru: "Emirates Gardens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "ea638712-7c0a-403b-b5f9-02aff8e074af",
    name: {
      ar: "مالطا",
      ru: "Malta",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ecceba4d-8564-4e3a-8713-401fec973081",
    name: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "ecdb2dfd-8953-47b5-bf3d-cb53c32a7b6e",
    name: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "eec926fb-a888-4f2d-b1c1-305161888148",
    name: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "",
      ru: "",
    },
  },
  {
    id: "efb00aa8-100e-4008-83ae-69c2cdec5041",
    name: {
      ar: "سانتوريني",
      ru: "Санторини",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f0e95c07-3e9f-45dc-9c6f-c2cd705bc063",
    name: {
      ar: "سيليستيا",
      ru: "Селестия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "f5b3f779-6efd-4225-8c13-2323dd3e01fa",
    name: {
      ar: "شقق أول سيزونز تراس",
      ru: "Апартаменты All Seasons Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f784a0c4-b695-4458-97bc-047bda930d9b",
    name: {
      ar: "جيمز استايتس",
      ru: "Gems Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "fbcfe278-83af-4767-8bc0-0dc6895cbf94",
    name: {
      ar: "برج الأمواج",
      ru: "Башня Волн",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "fbdb53a2-d8ec-4d4d-9c2f-7d31282d7640",
    name: {
      ar: "خليج مارينا",
      ru: "Марина Бэй",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "fc678e03-6d21-488f-9848-f793b3b6fdd1",
    name: {
      ar: "داماك ميزون مول ستريت",
      ru: "DAMAC Maison Mall Street",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "feada9b3-d073-46e7-bfc4-027d475ba72a",
    name: {
      ar: "برج أيكون سيتي سي",
      ru: "AYKON City Tower C",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
];

export const projectlocale = [
  {
    id: "8e8039d4-bfed-40e1-aea5-230691ad35c6",
    name: {
      ar: "داماك آيلاندز 2",
    },
    country: {
      ar: "الإمارات",
    },
    city: {
      ar: "دبي",
    },
    location: {
      ar: "جزر داماك 2، مجتمع",
    },
    area: {
      ar: "دبي لاند",
    },
  },
  {
    id: "c4e14545-82d7-4e2d-8f63-8c9a2cf94c34",
    name: {
      ar: "داماك ديستركت",
    },
    country: {
      ar: "الإمارات",
    },
    city: {
      ar: "دبي",
    },
    location: {
      ar: "داماك هيلز",
    },
    area: {
      ar: "دبي لاند",
    },
  },
  {
    id: "0ddece86-2e39-4077-a292-159e4a10dca7",
    name: {
      ar: "تشيلسي ريزيدنسز",
    },
    country: {
      ar: "الإمارات",
    },
    city: {
      ar: "دبي",
    },
    location: {
      ar: "",
    },
    area: {
      ar: "مدينة دبي البحرية",
    },
  },
  {
    id: "e269e105-0e82-44c1-addc-e2b10dff5849",
    name: {
      ar: "بيل إير في ترامب إستيتس",
      ru: "BelAir в Trump Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "66fbff46-b75f-462c-9770-02f9577ee591",
    name: {
      ar: "داماك آيلاندز",
      ru: "DAMAC Islands",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Islands Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2fd4cede-63d1-4035-8946-79043b8fb7a9",
    name: {
      ar: "داماك ريفرسايد",
      ru: "DAMAC Riverside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "bbd8e9d2-f4fb-4905-95ba-139ccded2078",
    name: {
      ar: "داماك ريفرسايد فيوز",
      ru: "Вид на реку DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "2c70e5f9-04b2-464a-8f9b-5659b944575d",
    name: {
      ar: "إيلو 3",
      ru: "ELO 3",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e81bfe40-e835-44d5-b7f6-36c2f5ac19bc",
    name: {
      ar: "كيارا في داماك هيلز",
      ru: "Kiara at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f8f87816-f5e0-42c5-9e35-91490a3cc985",
    name: {
      ar: "صفا جيت",
      ru: "Safa Gate",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "5659ee52-fae1-4f98-b7b3-70400978a84d",
    name: {
      ar: "شورلاين من داماك",
      ru: "Shoreline от DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "Ras Al Khaimah",
      ru: "Рас-эль-Хайма",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة المرجان",
      ru: "Остров Аль-Марджан",
    },
  },
  {
    id: "eb935481-89d5-4257-83c7-64fcc104e13d",
    name: {
      ar: "تاون هاوس في منطقة الجولف والحديقة",
      ru: "Таунхаусы на The Golf And The Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c2c0b19c-9966-4202-a511-1e7abb19ac85",
    name: {
      ar: "يوتوبيا",
      ru: "утопия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3861c01b-115d-4c1f-97de-732f6a4c5b20",
    name: {
      ar: "الفيولت 4",
      ru: "Violet 4",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "05818651-94b9-45dd-8cb0-b0bdecb3fa65",
    name: {
      ar: "داماك صن سيتي ",
      ru: "DAMAC Сан Сити ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Sun City Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "63424650-3caa-4c71-b953-0806d14d0f36",
    name: {
      ar: "إيلو 2",
      ru: "ELO 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b32500e7-4739-45fa-9509-607c36906c0c",
    name: {
      ar: "إيفرغرينز",
      ru: "Evergreens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1f3c59d9-b952-44c7-b080-e60b8bd465c2",
    name: {
      ar: "ناتورا ",
      ru: "Natura ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5a897c13-3ff3-48d5-9f89-ea1ac8698851",
    name: {
      ar: "برج جولف جرينز 2ب",
      ru: "ГОЛЬФ-ГРИНС ТАУЭР 2Б",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e4f3465b-741c-4726-af71-97a5645894d7",
    name: {
      ar: "مجموعة أوتوغراف",
      ru: "Autograph Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "26a67240-cb57-4258-8acd-6d7179ff4193",
    name: {
      ar: "إيلو",
      ru: "ELO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "59acd19b-e742-49fb-a1e9-bb9003ac0139",
    name: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "270e7d19-ad04-426a-aaab-f2ea9f77c7e4",
    name: {
      ar: "ألتيتيود دي جريسوغونو ",
      ru: "Altitude de GRISOGONO ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "bb1911f5-e114-438b-90a6-6ecccf450f01",
    name: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "659ec9a5-2831-4902-9f4a-eda5440a8a8d",
    name: {
      ar: "بارك جرينز - المرحلة الثانية",
      ru: "Парк Гринс - Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "55725ff4-fab5-496e-8766-112ddad23902",
    name: {
      ar: "غولف جيت 2",
      ru: "Golf Gate 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ec454b1d-f037-4f55-8d80-f2638861143f",
    name: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "09d041ed-66b5-4098-841e-f77211f505c7",
    name: {
      ar: "فولتا",
      ru: "VOLTA",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "f09361a1-ed6d-4ebf-9f97-4b28d6bac53d",
    name: {
      ar: "المغرب – المرحلة الثانية",
      ru: "Morocco – Phase 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3cb44e3c-2252-4ae7-ae21-8d930940d2cb",
    name: {
      ar: "الشعاب المرجانية",
      ru: "Коралловый Риф",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "df7b28a8-956f-4215-9b53-c612e337d836",
    name: {
      ar: "ذا فارم هاوسز",
      ru: "The Farmhouses",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "76e985fe-cc1a-4f6d-b7c8-d2835a65ad24",
    name: {
      ar: "فيرونا - داماك هيلز 2",
      ru: "Верона - DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3d1d3109-5e7e-42ad-9465-afd6ea4c4977",
    name: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d50cb862-cebd-4c2b-8fa4-6b140f1bbae3",
    name: {
      ar: "سكاي كرست كوليكشن",
      ru: "Skycrest Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "6259bfed-0764-4318-810e-6d4136907702",
    name: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4a51702c-72e1-4431-ac21-e36d80de5d3e",
    name: {
      ar: "بايز إيدج",
      ru: "Bay’s Edge",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "df8b2d0a-f2e7-4541-b751-d0e9ce1f2f60",
    name: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f78f025c-7147-4353-9e37-c9e747a10e9f",
    name: {
      ar: "ميكونوس",
      ru: "Mykonos",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a82e8a46-bb54-4abd-9ec5-0c7f2d8b0194",
    name: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "baee1129-e502-4bf3-95cc-51d4a10d61b8",
    name: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "21087e80-310e-4036-ad5e-22c8aba02e99",
    name: {
      ar: "هاربر لايتس دي جريسوغونو",
      ru: "HARBOUR LIGHTS DE GRISOGONO GENEVE",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "b2af26df-9fb9-4305-a903-d2ab1775128d",
    name: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "5beeab0d-3369-4850-9138-cd46091fb90b",
    name: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "fb236d2b-308b-4ee3-926f-c0acd82f2d74",
    name: {
      ar: "فندق داماك هيلز 2 إيدج من روتانا",
      ru: "DAMAC Hills 2 Hotel Edge by Rotana",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "625c5bca-aa24-481d-a2d0-000799d92a96",
    name: {
      ar: "فلل كاميليا",
      ru: "Camelia Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e0fe0183-bfd0-4080-80a5-ee440f7bca85",
    name: {
      ar: "فيرديس",
      ru: "Virdis",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "fd95ad3b-f62e-49a5-a67f-d23dc841b4ef",
    name: {
      ar: "إبيزا",
      ru: "Ibiza",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e38098e2-8bcc-4b10-b946-602f282dac02",
    name: {
      ar: "كوستا برافا ",
      ru: "Коста Брава ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "679f538d-6236-4180-a611-05eec1e31aee",
    name: {
      ar: "مونت كارلو",
      ru: "Monte Carlo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b8a6011e-86bb-420c-84dd-78333d8f22ab",
    name: {
      ar: "إليغانس تاور",
      ru: "Elegance Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "5674d289-6920-42a9-9709-9891ecc884db",
    name: {
      ar: "ماربيّا",
      ru: "Marbella",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "bac32669-3313-4735-b84b-2cc21959f813",
    name: {
      ar: "شيك تاور",
      ru: "Chic Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "03da29a0-93a9-4e9e-9c12-a40b942c0e90",
    name: {
      ar: "جيمز استايتس",
      ru: "Gems Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "05668ade-99b8-4aca-b985-aa5d7a5cf7c6",
    name: {
      ar: "بيفرلي هيلز درايف",
      ru: "Beverly Hills Drive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "db973691-b510-4943-ae54-3f42ef844095",
    name: {
      ar: "صفا تو دي غريسوغونو - البرج B",
      ru: "Safa Two de GRISOGONO - Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "00af1b08-e299-4ec8-9413-27daadcb3125",
    name: {
      ar: "صفا تو دي غريسوغونو",
      ru: "Safa Two de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "b37985f5-9d38-471a-ad86-e4894bc05c52",
    name: {
      ar: "مالطا",
      ru: "Malta",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "735558f7-b415-4d58-adb8-3fa98c2b75ce",
    name: {
      ar: "البندقية",
      ru: "Венеция",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1d8515ab-2b8b-40e2-be7d-c5ee58b976fe",
    name: {
      ar: "كافالي إستيتس",
      ru: "Кавалли Эстейтс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "dbf8a3fa-f06a-4a13-a2c9-d201a58331fc",
    name: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "61e3b11c-cd65-434e-baba-bde7c45cc8e4",
    name: {
      ar: "بورتوفينو",
      ru: "Портофино",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "54f0ca53-8ef9-4f1a-adbc-9f6f1279c7bb",
    name: {
      ar: "غولف جيت في داماك هيلز",
      ru: "Golf Gate в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "47a30c01-a045-4c89-9ecd-e0429ed839d7",
    name: {
      ar: "فلل إتيرنو بريستيج في داماك هيلز 2",
      ru: "Виллы Eterno Prestige в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e50988cf-e69a-42ce-8676-aa3be8d5694c",
    name: {
      ar: "نيس",
      ru: "Ницца",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "62b60a0d-93c5-4949-bfc6-f83045b5db0e",
    name: {
      ar: "سانتوريني",
      ru: "Санторини",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "fe4fc88e-be1e-48f3-8ce4-319d306e29b5",
    name: {
      ar: "برج كافالي",
      ru: "Башня Кавалли",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "5478d5d8-0a28-4301-a36b-06550168c53f",
    name: {
      ar: "داماك هيلز 2 (أكويا أكسجين)",
      ru: "DAMAC Hills 2 (AKOYA OXYGEN)",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9d1fbc61-86d4-464f-8ac7-4d5825d06959",
    name: {
      ar: "فلل بريستيج في داماك هيلز 2",
      ru: "Престижные виллы в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "454a0899-2863-40c8-939a-6681ea43708e",
    name: {
      ar: "ذا ليجندز",
      ru: "The Legends",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2d05a116-3dff-421a-87a3-55c51bdad47d",
    name: {
      ar: "فلل بريفيليج في داماك هيلز 2",
      ru: "Виллы Privilege в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f77a4918-940b-4bb7-8f7a-947dc9d401e3",
    name: {
      ar: "فلل بريميير في داماك هيلز 2",
      ru: "Виллы класса «Премьер» в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "40521c1c-8df8-4f54-80e5-a766f06e5b22",
    name: {
      ar: "جرينوودز",
      ru: "Гринвудс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "36902bcc-7056-4c06-a1d9-41c41bf66162",
    name: {
      ar: "جرين إيكرز في داماك هيلز",
      ru: "Green Acres в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d3abdb9e-9439-46ad-83ef-d096003df095",
    name: {
      ar: "قطع أراضي كانفاس بريميوم في داماك هيلز",
      ru: "Участки премиум-класса Canvas в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9f0cc2fd-ee04-4e5f-8e50-cd77272d1d08",
    name: {
      ar: "ملروز استايتس",
      ru: "Melrose Estates в Дамак Хиллз",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b0541556-0b4d-4d61-b9ad-5766fde53010",
    name: {
      ar: "داماك تاورز من باراماونت هوتيلز آند ريزورتس",
      ru: "DAMAC Towers by Paramount Hotels And  Resorts Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "b050efbf-c6fc-4e7f-88dc-313dec07402e",
    name: {
      ar: "شقق أول سيزونز تراس",
      ru: "Апартаменты All Seasons Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d1340068-39cf-43ed-85a5-e056995ab1cc",
    name: {
      ar: "باراماونت تاور هوتيل آند ريزيدنسز دبي",
      ru: "DAMAC Paramount Tower Hotel And Residences Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "763a70d1-6e43-4a02-9fea-f5c2864ac8cc",
    name: {
      ar: "بيل إير في ترامب إستيتس – المرحلة الثانية",
      ru: "BelAir в Trump Estates – Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3eda909d-7dd0-43f5-8997-daf0b1056894",
    name: {
      ar: "سيلفر سبرينغز في داماك هيلز",
      ru: "Silver Springs в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "34076d61-ac82-4c58-8643-96ffe14c5d78",
    name: {
      ar: "بيلفيستا في داماك هيلز",
      ru: "Беллависта в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "8a054a5a-8702-454e-8735-cebbb928c711",
    name: {
      ar: "فندق راديسون دبي داماك هيلز",
      ru: "Radisson Дубай DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "72687a85-ddd4-4757-a2c4-52bbc53a8b90",
    name: {
      ar: "حدائق عالية في داماك هيلز",
      ru: "Высокие сады в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "0c4506a1-a39c-4534-a235-d1af7ec33dca",
    name: {
      ar: "لوريتو في داماك هيلز",
      ru: "Loreto at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "bfe10f6e-02f1-4eac-acd0-7e162ed10d5e",
    name: {
      ar: "برج زاده",
      ru: "Zada Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f9d3fb92-a805-4a49-b33c-6afe7a3a79aa",
    name: {
      ar: "ورد",
      ru: "Цветок",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ab8f0b4e-b9e0-4b36-8fab-d436f959f53a",
    name: {
      ar: "أمورا",
      ru: "Amora",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "79d755c0-79df-4c3d-8a59-06319a683be2",
    name: {
      ar: "جولف تاون في داماك هيلز",
      ru: "Гольф-городок в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5cc02a8a-5c9c-4917-90b3-836438a12159",
    name: {
      ar: "بارك تاون في داماك هيلز",
      ru: "Парк Таун в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4fdfd08f-b758-47ff-9b43-0600a7c0fbee",
    name: {
      ar: "بوتيك فيلاز 90210",
      ru: "90210 Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1906b894-6cfd-4d0b-96a2-770156f3642a",
    name: {
      ar: "غرين بارك",
      ru: "Green Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "319d0593-db1a-4bd6-98ba-808ff6c367bc",
    name: {
      ar: "ريفا ريزيدنسز",
      ru: "Резиденции Рева",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "76ec1393-606c-4428-8a3a-a8158a4c373f",
    name: {
      ar: "فلل بارك في داماك هيلز",
      ru: "Виллы Park в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "21794f25-f45a-4d36-9b7e-68b2c10c6e4a",
    name: {
      ar: "غولف فيتا في داماك هيلز",
      ru: "Golf Vita at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e3517e6f-0401-495a-b2f2-6677f94cb0f1",
    name: {
      ar: "فلل فينيتو في داماك هيلز",
      ru: "Виллы Венето в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "08f11c88-ad64-49e6-95ff-c12bb813dfaa",
    name: {
      ar: "فلل أفينسيا",
      ru: "Виллы Авенсия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "7988cb74-9878-498b-896f-4f1884045974",
    name: {
      ar: "فلل رويال غولف بوتيك",
      ru: "Royal Golf Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "عقارات جميرا للغولف",
      ru: "Jumeirah Golf Estates",
    },
  },
  {
    id: "0e9763ba-b8a6-4a7b-a5a6-ce7e8b586d1d",
    name: {
      ar: "برج أيكون سيتي سي",
      ru: "AYKON City Tower C",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "4fa688eb-ece3-4838-862a-db8595395d27",
    name: {
      ar: "برج أيكون سيتي ب",
      ru: "AYKON City Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "1a45a934-c9a6-462c-9efe-535435a3ba77",
    name: {
      ar: "برج ميرانو",
      ru: "Merano Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f92a446f-e74b-455c-9b84-c6688cf6079a",
    name: {
      ar: "فيرا ريزيدنسز",
      ru: "Резиденции Вера",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "01199bff-a938-428a-9d88-d9dace67c716",
    name: {
      ar: "أفانتي",
      ru: "Avanti",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "2bf1e854-2f97-4753-b6a7-319fdf76da3d",
    name: {
      ar: "داماك ماجستين",
      ru: "DAMAC Majestine",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "93a13cd3-10b6-4cad-8b74-c2396b9f7e5e",
    name: {
      ar: "غالية",
      ru: "Галия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "74d727e4-3702-4d59-a09d-0dae4d5e977b",
    name: {
      ar: "تاور 108",
      ru: "Tower 108",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "e6703b77-7be2-4866-8840-f373de96d6a4",
    name: {
      ar: "سيليستيا",
      ru: "Селестия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "c222755c-186c-4455-8f05-5b1f1996972b",
    name: {
      ar: "ترامب إستيتس في داماك هيلز",
      ru: "Поместья Трампа в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6e724677-438b-477f-a621-41bbb208d038",
    name: {
      ar: "داماك بريفيه",
      ru: "DAMAC Prive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f3c74210-04d4-4764-aceb-3d9ea6ea7932",
    name: {
      ar: "فلل داماك من باراماونت هوتيلز آند ريزورتس دبي",
      ru: "Виллы DAMAC от Paramount Hotels And Resorts Дубай",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9b483124-29dd-43f3-86a9-d3a18ad63488",
    name: {
      ar: "لينكولن بارك",
      ru: "Lincoln Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أرجان",
      ru: "Арджан",
    },
  },
  {
    id: "8664c59d-279a-4931-b7b4-9dd3dc04728c",
    name: {
      ar: "داماك ميزون مول ستريت",
      ru: "DAMAC Maison Mall Street",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "a7db49ae-cf1f-431e-b4c1-27a4ea5fb594",
    name: {
      ar: "داماك ريزيدنزيه",
      ru: "DAMAC Residenze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "1d1ec8fa-3384-461a-bdcf-3f77a457038c",
    name: {
      ar: "داماك سوبيربيا",
      ru: "DAMAC Suburbia",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
  },
  {
    id: "b8497b07-ebc0-4e74-9c2b-35f5fe9d0f40",
    name: {
      ar: "داماك ميزون ديستنكشن",
      ru: "DAMAC Maison Distinction",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "6c96189b-c14f-4b6f-a9cb-646af34f61b6",
    name: {
      ar: "داماك بريز",
      ru: "DAMAC Breeze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "ebc970b7-dd4f-4cd5-a027-d43555c5cf48",
    name: {
      ar: "داماك ميزون كنال فيوز",
      ru: "DAMAC Maison Canal Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f6716613-8e35-4416-ad6e-e6158b86a065",
    name: {
      ar: "داماك فوليو",
      ru: "DAMAC Voleo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "ea5fb5bf-606a-41c3-ad9e-f17de1538b33",
    name: {
      ar: "إكزكتيف باي",
      ru: "Executive Bay",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "8d4fa6ff-2857-4ad8-bbf1-625040d121cf",
    name: {
      ar: "داماك ميزون كور جاردان",
      ru: "DAMAC Maison Cour Jardin",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "2ef5386a-a6a7-4685-9b99-4349f69482fd",
    name: {
      ar: "بارك سنترال",
      ru: "Park Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "منطقة البرج",
      ru: "Район Бурдж",
    },
  },
  {
    id: "cf54fca9-6a64-4a19-855c-c4523221ab96",
    name: {
      ar: "أبر كرست",
      ru: "Upper Crest",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "2e8765d5-ab7a-4929-9aa9-750ef785fcc3",
    name: {
      ar: "ذا ريزيدنسز في بزنس سنترال",
      ru: "The Residences at Business Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "0ed3c195-ab2e-4814-9141-f8a785ede069",
    name: {
      ar: "تينورا ",
      ru: "Tenora ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "c535f675-1d05-4063-994c-934fbf7bb912",
    name: {
      ar: "لايك سايد",
      ru: "Lakeside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "a3b87df9-eb5a-4020-96ec-df992f501f83",
    name: {
      ar: "خليج مارينا",
      ru: "Марина Бэй",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "493e40b8-7165-4419-934c-aaef364a8b10",
    name: {
      ar: "ماديسون ريزيدنسز",
      ru: "Madison Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ماجان",
      ru: "Majan",
    },
  },
  {
    id: "fc6cc162-aba1-425c-903d-4e0c0f569a48",
    name: {
      ar: "داماك هايتس",
      ru: "DAMAC Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "884547ea-8895-445b-8205-98e3935ac149",
    name: {
      ar: "لاغو فيستا",
      ru: "Lago Vista",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "c6564a23-e947-43d0-a993-d0563623c86b",
    name: {
      ar: "لايك فيو",
      ru: "Lake View",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "c735164a-eccc-4a48-bfcd-7caf02e69517",
    name: {
      ar: "توسكان ريزيدنسز",
      ru: "Tuscan Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "9dc8cdb5-eeb4-40ac-9163-eb5ee9e005a1",
    name: {
      ar: "بزنس تاور",
      ru: "Business Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "d7e5438f-6746-4371-b6bc-144c225a3490",
    name: {
      ar: "أوشن سكيب",
      ru: "Oceanscape",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "f26acbba-6c25-433b-a167-859abfa624b4",
    name: {
      ar: "سمارت هايتس",
      ru: "Smart Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "c3d3dbfb-ccb6-4493-97d9-51d11f2d889f",
    name: {
      ar: "برج إكس إل",
      ru: "XL Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "e90de643-3422-4fc1-ba86-98ebdc04932f",
    name: {
      ar: "إﻳﻤﻴﺮﻳﺘﺲ ﺟﺎردﻧﺰ",
      ru: "Emirates Gardens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "f319b7d7-e90a-4221-a611-186c74df25e5",
    name: {
      ar: "داماك إكزكيوتف هايتس",
      ru: "DAMAC Executive Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "056bcf83-043f-4065-aadb-53042b1066aa",
    name: {
      ar: "ذا كريسنت",
      ru: "The Crescent",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "5d859e44-f353-47c3-af8b-e814a2e35035",
    name: {
      ar: "أوشن هايتس",
      ru: "Ocean Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "9889ea68-2754-4684-9686-81d834bd169a",
    name: {
      ar: "أبراج بارك",
      ru: "Парковые башни",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مركز دبي المالي العالمي",
      ru: "Дубайский международный финансовый центр",
    },
  },
  {
    id: "f1801e13-c3b9-4b41-8bd5-6253c01df6fd",
    name: {
      ar: "لايك تيراس",
      ru: "Lake Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "007cb4dc-b714-4f29-92f9-13683c24bbdb",
    name: {
      ar: "برج الأمواج",
      ru: "Башня Волн",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "86d257e0-f2d6-4c25-bf0c-352bd9e5d3e4",
    name: {
      ar: "مارينا تيراس",
      ru: "Marina Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },

  {
    id: "5a297d3c-95ff-499a-a1fb-e6ed7dc0566e",
    name: {
      ar: "بيل إير في ترامب إستيتس",
      ru: "BelAir в Trump Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ae446c85-0fea-4258-a2c7-e6eedfb2ad49",
    name: {
      ar: "داماك آيلاندز",
      ru: "DAMAC Islands",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Islands Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "adacd4b8-a20a-493b-9c45-535147764782",
    name: {
      ar: "داماك ريفرسايد",
      ru: "DAMAC Riverside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "9fad14fb-cb65-43f3-b165-28cb63b58d80",
    name: {
      ar: "داماك ريفرسايد فيوز",
      ru: "Вид на реку DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "b4aa9f6a-1f7a-4fa2-b2fc-848ae60baa56",
    name: {
      ar: "إيلو 3",
      ru: "ELO 3",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "faed4a2c-ea58-44fb-bb9e-23e5e03e8abe",
    name: {
      ar: "كيارا في داماك هيلز",
      ru: "Kiara at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d5e1ef43-106a-4fa5-af6a-10c59d91e0e5",
    name: {
      ar: "صفا جيت",
      ru: "Safa Gate",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "813a925c-2d8a-457c-8e00-4187182f8f8a",
    name: {
      ar: "شورلاين من داماك",
      ru: "Shoreline от DAMAC",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "رأس الخيمة",
      ru: "Рас-эль-Хайма",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة المرجان",
      ru: "Остров Аль-Марджан",
    },
  },
  {
    id: "927fc972-a452-4c02-b89c-3eed2d011ec2",
    name: {
      ar: "تاون هاوس في منطقة الجولف والحديقة",
      ru: "Таунхаусы на The Golf And The Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "7781eb40-95c5-4d76-9f35-0448dbef31b6",
    name: {
      ar: "يوتوبيا",
      ru: "утопия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d0052e87-7501-47a6-92ae-41c99662176d",
    name: {
      ar: "فيولت 4",
      ru: "Violet 4",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "187be4c6-befa-4bc7-8d6e-34ad9dfd663f",
    name: {
      ar: "داماك صن سيتي ",
      ru: "DAMAC Сан Сити ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "DAMAC Sun City Community",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e850bc06-b4a8-4b00-939c-61f2f9450f29",
    name: {
      ar: "إيلو 2",
      ru: "ELO 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "0d9f91e0-0fe6-43dd-8fb1-ba48e531f1bd",
    name: {
      ar: "إيفرغرينز",
      ru: "Evergreens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "24faafbe-d3c1-4075-b7e8-b53de90d752d",
    name: {
      ar: "ناتورا ",
      ru: "Natura ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2da9dab1-42ed-4826-910d-e6404f86319e",
    name: {
      ar: "برج جولف جرينز 2ب",
      ru: "GOLF GREENS БАШНЯ 2B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "404d7d3f-1cda-4216-9ba0-3cb15f603dea",
    name: {
      ar: "مجموعة أوتوغراف",
      ru: "Autograph Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "cae5bdb4-7a3e-4491-988a-bc83d8f3fcc7",
    name: {
      ar: "إيلو",
      ru: "ELO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "88cf7756-5295-4e3f-891a-bcbd584ea73f",
    name: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "1176d274-3aa8-40b1-8a4d-39d81c013d6a",
    name: {
      ar: "ألتيتيود دي جريسوغونو ",
      ru: "Altitude de GRISOGONO ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f57fa588-2a53-4056-bb19-14e36fe0ccdf",
    name: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6cf7a9bb-925f-44e7-8e6d-49dcf79a6bd8",
    name: {
      ar: "بارك جرينز - المرحلة الثانية",
      ru: "Парк Гринс - Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6f6e5664-55e5-4a15-83e2-86b88e2256cd",
    name: {
      ar: "غولف جيت 2",
      ru: "Golf Gate 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "94202b79-39a0-497f-8252-70ccd19e6d95",
    name: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "67471190-4d10-44a9-88e1-5b5173650ab5",
    name: {
      ar: "فولتا",
      ru: "VOLTA",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "82f2ee65-74b6-497a-98ac-4bd924d4b80c",
    name: {
      ar: "المغرب – المرحلة الثانية",
      ru: "Morocco – Phase 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "fd5ddc63-0fdc-465b-8874-66f00348e802",
    name: {
      ar: "الشعاب المرجانية",
      ru: "Коралловый Риф",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "6b3b7d87-e119-448d-bc75-1329bb6de40b",
    name: {
      ar: "ذا فارم هاوسز",
      ru: "The Farmhouses",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "259a0a85-078e-448d-b5d3-34def3d27005",
    name: {
      ar: "فيرونا - داماك هيلز 2",
      ru: "Верона - DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4761cb76-7648-4f7a-9556-dfb826b2687a",
    name: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "34fa483a-e51e-479a-b54e-2ed64b0d7027",
    name: {
      ar: "سكاي كرست كوليكشن",
      ru: "Skycrest Collection",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "571116bc-eff8-45b8-954c-999a418eec2e",
    name: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "cf69082e-7ea5-49b5-ab56-09ccd774b894",
    name: {
      ar: "بايز إيدج",
      ru: "Bay’s Edge",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "40e4d71d-2bd3-466a-a7e2-b3496659e420",
    name: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "24296221-d8c7-4410-9629-0bc9b3edaaa3",
    name: {
      ar: "ميكونوس",
      ru: "Mykonos",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "264646ed-50f3-495e-8f1a-d031edb266ce",
    name: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "982723ac-bf92-4758-8921-65187866bc4f",
    name: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "4e0057df-206d-4ff8-a4c5-1bd8c87bd339",
    name: {
      ar: "هاربر لايتس دي جريسوغونو",
      ru: "HARBOUR LIGHTS DE GRISOGONO GENEVE",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "a7325a52-1ba5-410a-bf6c-1f0636b20b3e",
    name: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "59155c87-12c1-4d55-b53d-e3cebe076f9d",
    name: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "10e234ab-0bbb-40d7-8144-e997857c4985",
    name: {
      ar: "فندق داماك هيلز 2 إيدج من روتانا",
      ru: "DAMAC Hills 2 Hotel Edge by Rotana",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "65c5b90f-2220-4001-bced-cc21374ededf",
    name: {
      ar: "فلل كاميليا",
      ru: "Camelia Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4e0062a1-c1b2-4211-82f8-cdbd3b703d21",
    name: {
      ar: "فيرديس",
      ru: "Virdis",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2e3c6de1-3674-43f2-8e85-fbdfe873c45e",
    name: {
      ar: "إبيزا",
      ru: "Ibiza",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "0a976aa7-80cc-458e-bcc2-4f035514a0e0",
    name: {
      ar: "كوستا برافا ",
      ru: "Коста Брава ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d6b9adf0-8b0d-4645-a4b0-fc24d19af18e",
    name: {
      ar: "مونت كارلو",
      ru: "Monte Carlo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "84518cb9-7176-480b-afce-b96b6f5d6d9c",
    name: {
      ar: "إليغانس تاور",
      ru: "Elegance Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "67183256-999d-4fd7-8637-76fd21e728ff",
    name: {
      ar: "ماربيّا",
      ru: "Marbella",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3c2b1ee9-0e8c-4f16-8171-fa560ff51c00",
    name: {
      ar: "شيك تاور",
      ru: "Chic Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f74334d8-25ac-4396-ac30-d86b41f056fa",
    name: {
      ar: "جيمز استايتس",
      ru: "Gems Estates",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ad3bb77d-8abd-4258-b617-14464d2a1dab",
    name: {
      ar: "بيفرلي هيلز درايف",
      ru: "Beverly Hills Drive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a8872ce3-7f03-4425-ad54-b85eba670780",
    name: {
      ar: "صفا تو دي غريسوغونو - البرج B",
      ru: "Safa Two de GRISOGONO - Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "d44c4c41-767a-4d67-87de-db3c5a4f408b",
    name: {
      ar: "صفا تو دي غريسوغونو",
      ru: "Safa Two de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "ea25afe6-3e34-4dff-aff9-e840bfe818ed",
    name: {
      ar: "مالطا",
      ru: "Malta",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c9bcfbd9-b567-4f4e-9e8f-1074edc76480",
    name: {
      ar: "البندقية",
      ru: "Венеция",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b0d7db2a-74a8-4fc5-a322-3cc6d23e263c",
    name: {
      ar: "كافالي إستيتس",
      ru: "Кавалли Эстейтс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "677b86f2-4d31-48a8-8bb6-2195a7ca9aab",
    name: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "d5decbe3-c3ee-4743-8cd5-b1432f9bde3c",
    name: {
      ar: "بورتوفينو",
      ru: "Портофино",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6e2989dd-d532-4e87-a50c-5965409f0227",
    name: {
      ar: "غولف جيت في داماك هيلز",
      ru: "Golf Gate в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a287cbe6-80b7-4c86-bb57-372cd8b47483",
    name: {
      ar: "فلل إتيرنو بريستيج في داماك هيلز 2",
      ru: "Виллы Eterno Prestige в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "74e8e41f-d6ce-4186-a699-d057d194365a",
    name: {
      ar: "نيس",
      ru: "Ницца",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "522fbbe3-2d98-4ba7-b08e-531ac37823b6",
    name: {
      ar: "سانتوريني",
      ru: "Санторини",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "cbd7c1fb-946e-48fd-a938-f447a37a0ad0",
    name: {
      ar: "برج كافالي",
      ru: "Башня Кавалли",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "62bc3039-698e-4da8-88be-7c9fc9769a40",
    name: {
      ar: "داماك هيلز 2 (أكويا أكسجين)",
      ru: "DAMAC Hills 2 (AKOYA OXYGEN)",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3ec4907d-dbca-4bdd-abba-43853bc346df",
    name: {
      ar: "فلل بريستيج في داماك هيلز 2",
      ru: "Престижные виллы в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6d540d50-6183-4303-a5fe-ebfb77eafd0f",
    name: {
      ar: "ذا ليجندز",
      ru: "The Legends",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9a65d9c2-ea1e-4566-bb76-74b4f058bf3b",
    name: {
      ar: "فلل بريفيليج في داماك هيلز 2",
      ru: "Виллы Privilege в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b9c93233-3714-4003-902d-560442d59298",
    name: {
      ar: "فلل بريميير في داماك هيلز 2",
      ru: "Виллы класса «Премьер» в DAMAC Hills 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "9e41326e-5ae9-4fcb-be24-28eb3570147c",
    name: {
      ar: "جرينوودز",
      ru: "Гринвудс",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "caca9ad0-2ddc-49da-9fe7-28b574bd4d20",
    name: {
      ar: "جرين إيكرز في داماك هيلز",
      ru: "Green Acres в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e947ee53-8d11-424e-9370-68af3840490f",
    name: {
      ar: "قطع أراضي كانفاس بريميوم في داماك هيلز",
      ru: "Участки премиум-класса Canvas в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "addb2106-19bf-47f7-b30f-2d871a81d794",
    name: {
      ar: "ملروز استايتس",
      ru: "Melrose Estates at Damac Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b8566c8d-3db0-4955-bfb8-958dc5cfd2b7",
    name: {
      ar: "داماك تاورز من باراماونت هوتيلز آند ريزورتس",
      ru: "DAMAC Towers by Paramount Hotels And  Resorts Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "cfc703a5-9060-4795-9a1f-caa192eed381",
    name: {
      ar: "شقق أول سيزونز تراس",
      ru: "Апартаменты All Seasons Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "16a6b625-53b7-41cd-bb9e-f0e717e573dd",
    name: {
      ar: "باراماونت تاور هوتيل آند ريزيدنسز دبي",
      ru: "DAMAC Paramount Tower Hotel And Residences Dubai",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "cee7334b-625b-4bee-84f4-b70f17109dcb",
    name: {
      ar: "بيل إير في ترامب إستيتس – المرحلة الثانية",
      ru: "BelAir в Trump Estates – Фаза 2",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "DAMAC Hills",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1749f567-ae27-4a04-995d-ac3242e3eb1b",
    name: {
      ar: "سيلفر سبرينغز في داماك هيلز",
      ru: "Silver Springs в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4867131c-2269-4775-b391-5110d2d924a2",
    name: {
      ar: "بيلفيستا في داماك هيلز",
      ru: "Беллависта в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "2039ae31-e7fe-46aa-abdc-f0b2d84293c3",
    name: {
      ar: "فندق راديسون دبي داماك هيلز",
      ru: "Radisson Дубай DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "417115fd-3d63-4b1d-920f-13a7b031c4a0",
    name: {
      ar: "حدائق عالية في داماك هيلز",
      ru: "Высокие сады в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "472da5b6-ccfd-459d-a353-23159adccd9a",
    name: {
      ar: "لوريتو في داماك هيلز",
      ru: "Loreto at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a8e490b1-3566-4846-a0a3-a1b8cae5ed83",
    name: {
      ar: "برج زاده",
      ru: "Zada Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "20b153be-df3c-4bb0-9a77-c2a8178b1f91",
    name: {
      ar: "ورد",
      ru: "Цветок",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "23a0d4b2-8e88-424f-a004-7911fcf0c778",
    name: {
      ar: "أمورا",
      ru: "Amora",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1f40501c-4e08-4b8e-b767-a008b96212af",
    name: {
      ar: "جولف تاون في داماك هيلز",
      ru: "Гольф-городок в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5778e607-8d54-44ea-aa33-1920633b889c",
    name: {
      ar: "بارك تاون في داماك هيلز",
      ru: "Парк Таун в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "77b20e84-9481-43ef-8235-83d29d358848",
    name: {
      ar: "بوتيك فيلاز 90210",
      ru: "90210 Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "c76c75f1-33a7-4746-9938-711598a2b85b",
    name: {
      ar: "غرين بارك",
      ru: "Green Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "5047a538-c9e6-4fe9-81cb-83f8f9e3da9b",
    name: {
      ar: "ريفا ريزيدنسز",
      ru: "Резиденции Рева",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "c128f387-ceba-459b-9e7e-904a0ca738ed",
    name: {
      ar: "فلل بارك في داماك هيلز",
      ru: "Виллы Park в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "12c5a43d-3d81-4e15-8635-bb08171af2b1",
    name: {
      ar: "غولف فيتا في داماك هيلز",
      ru: "Golf Vita at DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "aa14dc04-5fbc-45b5-aa02-34696be2cabf",
    name: {
      ar: "فلل فينيتو في داماك هيلز",
      ru: "Виллы Венето в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e2c3c48a-bc99-4f16-9b32-a7ca7bb7fb2b",
    name: {
      ar: "فلل أفينسيا",
      ru: "Виллы Авенсия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a104f648-ecd4-45e4-a708-ce77e212354c",
    name: {
      ar: "فلل رويال غولف بوتيك",
      ru: "Royal Golf Boutique Villas",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "عقارات جميرا للغولف",
      ru: "Jumeirah Golf Estates",
    },
  },
  {
    id: "343c6225-bdb8-4f1e-9f1d-3836d569ad35",
    name: {
      ar: "برج أيكون سيتي سي",
      ru: "AYKON City Tower C",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "27f0759d-d6ab-42da-836f-a646eb5cf8ca",
    name: {
      ar: "برج أيكون سيتي ب",
      ru: "AYKON City Tower B",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "6c6b4820-9fbe-45a5-8a59-3df7143e9be9",
    name: {
      ar: "برج ميرانو",
      ru: "Merano Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "88e9828c-d7e5-4c11-882c-0168b45bf545",
    name: {
      ar: "فيرا ريزيدنسز",
      ru: "Резиденции Вера",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "24fd2b31-4fb4-43c4-b731-907a6b9d6df7",
    name: {
      ar: "أفانتي",
      ru: "Avanti",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "cbdf7cba-1326-4b42-b3fc-daec168acc43",
    name: {
      ar: "داماك ماجستين",
      ru: "DAMAC Majestine",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "4892bb48-1c9e-45ac-98a3-b89dbfbff807",
    name: {
      ar: "غالية",
      ru: "Галия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "78979cf0-3325-4d89-bc1a-e935c4533400",
    name: {
      ar: "تاور 108",
      ru: "Tower 108",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "61e02cfc-bdda-4a26-993e-24ca76849e43",
    name: {
      ar: "سيليستيا",
      ru: "Селестия",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "e8e3aed0-b580-4dcb-ab42-e88b8e664731",
    name: {
      ar: "ترامب إستيتس في داماك هيلز",
      ru: "Trump Estates в DAMAC Hills",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "216b1b05-7c27-402c-b5fa-94ccabc52b53",
    name: {
      ar: "داماك بريفيه",
      ru: "DAMAC Prive",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f3392e64-077a-4a2d-8e7c-97644e0923f0",
    name: {
      ar: "فلل داماك من باراماونت هوتيلز آند ريزورتس دبي",
      ru: "Виллы DAMAC от Paramount Hotels And Resorts Дубай",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e490b4ce-9b44-47bc-91aa-d7922f67b523",
    name: {
      ar: "لينكولن بارك",
      ru: "Lincoln Park",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أرجان",
      ru: "Арджан",
    },
  },
  {
    id: "0f381887-a482-4760-884f-1a9b109aa4f4",
    name: {
      ar: "داماك ميزون مول ستريت",
      ru: "DAMAC Maison Mall Street",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "56150626-7010-4ec8-8b11-fad8b92433bc",
    name: {
      ar: "داماك ريزيدنزيه",
      ru: "DAMAC Residenze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "034a214d-2d72-49f3-b4b9-b2014615d872",
    name: {
      ar: "داماك سوبيربيا",
      ru: "DAMAC Suburbia",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
  },
  {
    id: "94a522df-fac3-467d-b88b-2246f206adbe",
    name: {
      ar: "داماك ميزون ديستنكشن",
      ru: "DAMAC Maison Distinction",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "8120aa52-86d2-4a3f-8cbf-97de8c8ea929",
    name: {
      ar: "داماك بريز",
      ru: "DAMAC Breeze",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "4bc60e7f-3e47-4b94-b605-fcedc82f3275",
    name: {
      ar: "داماك ميزون كنال فيوز",
      ru: "DAMAC Maison Canal Views",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "21cd82a4-8f21-4ae4-a480-8c8cd56c8a32",
    name: {
      ar: "داماك فوليو",
      ru: "DAMAC Voleo",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "4ca286bc-d51c-4980-a553-0542a9b418b6",
    name: {
      ar: "إكزكتيف باي",
      ru: "Executive Bay",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "08a5e92f-5c61-442b-af5a-a75b1a1a5121",
    name: {
      ar: "داماك ميزون كور جاردان",
      ru: "DAMAC Maison Cour Jardin",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "e61adca0-90e9-4352-9c89-18caa974ee35",
    name: {
      ar: "بارك سنترال",
      ru: "Park Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "منطقة البرج",
      ru: "Район Бурдж",
    },
  },
  {
    id: "fa208b01-a375-4377-ab43-26d9d37264e0",
    name: {
      ar: "أبر كرست",
      ru: "Upper Crest",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "e0f7aace-7201-4c82-867a-2c1adade0fd4",
    name: {
      ar: "ذا ريزيدنسز في بزنس سنترال",
      ru: "The Residences at Business Central",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "8a87f195-c980-4cf9-8a51-3912ece827f5",
    name: {
      ar: "تينورا ",
      ru: "Tenora ",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "دبي الجنوب",
      ru: "Dubai South",
    },
  },
  {
    id: "15c5530f-427c-436a-b85b-51773043660b",
    name: {
      ar: "لايك سايد",
      ru: "Lakeside",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "24a50dfd-263b-434b-9643-c9412a294cf2",
    name: {
      ar: "خليج مارينا",
      ru: "Марина Бэй",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "441680e5-ad71-4e8d-b593-64f28587aa5f",
    name: {
      ar: "ماديسون ريزيدنسز",
      ru: "Madison Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ماجان",
      ru: "Majan",
    },
  },
  {
    id: "2923bba1-06bd-423e-84fe-c02829ef7c67",
    name: {
      ar: "داماك هايتس",
      ru: "DAMAC Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "866ad88c-42f2-4138-988b-29b0bee5af1d",
    name: {
      ar: "لاغو فيستا",
      ru: "Lago Vista",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "2df6dbde-ff4d-404a-8291-743027e265a3",
    name: {
      ar: "لايك فيو",
      ru: "Lake View",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "76a5f7ab-ca85-499c-8de8-6eca5cf1a519",
    name: {
      ar: "توسكان ريزيدنسز",
      ru: "Tuscan Residences",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "0913b105-e42b-4db3-8899-f27970bac1b7",
    name: {
      ar: "بزنس تاور",
      ru: "Business Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "c0e7fcc6-806c-49a5-aaff-11662880591c",
    name: {
      ar: "أوشن سكيب",
      ru: "Oceanscape",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "أبو ظبي",
      ru: "Абу-Даби",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جزيرة الريم",
      ru: "Остров Аль-Реем",
    },
  },
  {
    id: "7b81770c-2205-4158-831e-11bbfcd8ba7d",
    name: {
      ar: "سمارت هايتس",
      ru: "Smart Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "c80486a0-ef99-49e3-a671-61125f58489b",
    name: {
      ar: "برج إكس إل",
      ru: "XL Tower",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "d4e9a91f-ecc6-4152-b6c3-791bfae9ab04",
    name: {
      ar: "إﻳﻤﻴﺮﻳﺘﺲ ﺟﺎردﻧﺰ",
      ru: "Emirates Gardens",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "قرية جميرا الدائرية",
      ru: "Jumeirah Village Circle",
    },
  },
  {
    id: "53f554ea-0b3c-40bb-ad79-d41c51f34a81",
    name: {
      ar: "داماك إكزكيوتف هايتس",
      ru: "DAMAC Executive Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "برشا هايتس تيكوم",
      ru: "Барша Хайтс TECOM",
    },
  },
  {
    id: "276dee13-6e65-4337-a462-ac7fd9021fab",
    name: {
      ar: "ذا كريسنت",
      ru: "The Crescent",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "0c259382-2402-408e-8f3b-189d1dfde4ac",
    name: {
      ar: "أوشن هايتس",
      ru: "Ocean Heights",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "2f607943-fac7-447f-9558-fc6468880599",
    name: {
      ar: "أبراج بارك",
      ru: "Парковые башни",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مركز دبي المالي العالمي",
      ru: "Дубайский международный финансовый центр",
    },
  },
  {
    id: "fec2b336-fd15-4fef-bfe3-8fbb5c38a7ab",
    name: {
      ar: "لايك تيراس",
      ru: "Lake Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "أبراج بحيرات جميرا",
      ru: "Башни Джумейра Лейкс",
    },
  },
  {
    id: "1d127e37-a8e8-42ac-947a-065176a69c20",
    name: {
      ar: "برج الأمواج",
      ru: "Башня Волн",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
  {
    id: "dc907a30-fdac-423e-b58e-a407ba920217",
    name: {
      ar: "مارينا تيراس",
      ru: "Marina Terrace",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مرسى دبي",
      ru: "Дубай Марина",
    },
  },
];

export const propertyTypelocale = [
  {
    id: "c30d6f0c-cf08-4cf8-87c6-d5990d02e4be",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيلو 3",
      ru: "ELO 3",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "949e038e-9e22-4ecb-8d6e-5e39f8a09594",
    name: {
      ar: "7 فيلا",
      ru: "7 Вилла",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "يوتوبيا",
      ru: "утопия",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "6b6613eb-1aa4-4fe9-893b-93aeac603934",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيلو 2",
      ru: "ELO 2",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b0be001f-70bd-4cbb-9daf-9362a4bfff0e",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيفرغرينز",
      ru: "Evergreens",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "bbb457f7-7595-409d-bd12-1d738dd068f1",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيلو",
      ru: "ELO",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b353fb3f-030b-4a80-85e1-1335b2f6b506",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "15e561d7-d587-4bd4-9da6-78f942c8d68b",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "a546b8c4-d85c-43a4-8edf-8ccf1f61703f",
    name: {
      ar: "5 شقق",
      ru: "5 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "5f1b2906-9af0-4b19-bece-fcb0a5a62412",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "ألتيتيود دي جريسوغونو",
      ru: "Altitude de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "89f89e68-cc1c-467f-ade0-87a3dabf31f4",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "ألتيتيود دي جريسوغونو",
      ru: "Altitude de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "94b72e1d-3722-426f-a0f7-9192b248104e",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "db02bca5-7661-481c-85d8-3e034c955aec",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "12696ca3-2dab-48b7-9623-b1a386380de8",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف جيت 2",
      ru: "Golf Gate 2",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b0d3403d-3c9a-4b28-89ad-fc0d6f91d5a3",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "9f281776-d84f-489d-872b-21dc034b12a1",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "a789f80d-081b-47b2-931c-00d62df62d48",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "532b3199-0f53-4292-bd59-6809f6bd52ad",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "5451ec42-9078-4dc3-b05c-ecc1ff150062",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "وقت",
      ru: "VOLTA",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "614c2df6-96d6-4dd5-8d28-57599ee046cc",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "وقت",
      ru: "VOLTA",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "c6b233a6-0034-4aa1-8d46-01ece076af22",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "وقت",
      ru: "VOLTA",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "6068b963-d9e7-46cb-b0a0-9dfe98212bcd",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "e42e5c0f-8a93-4cd2-a253-47069609166a",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ab459d90-1363-42bd-8af6-4c48c631dc5c",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "41ed6da9-fb23-4abf-bc96-cd799de826cb",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "37b984c0-17ab-43d6-8c68-7e1f08ce6013",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "3beadf89-3cf4-42e2-83c8-fff78cc5043f",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "18a79b20-9bf8-4867-b99f-06d18db1b8ee",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "0738e5ee-09fe-4f58-9ada-c196ae360aea",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "1b0c2297-c55e-4669-979a-35db07f6c3e5",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "a736b22b-aea7-4c63-956b-540f72b1fc45",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "f9183783-1462-4ba3-af05-6c111a5a1d4f",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "هاربر لايتس دي جريسوغونو",
      ru: "HARBOUR LIGHTS DE GRISOGONO GENEVE",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "3a59e8d1-4059-4c2f-a3e2-1512a82fcc8e",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "6e3f8584-211a-46c9-9de2-76097436cff3",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "ad2faa3c-d2ce-460e-b239-7fdb1f2c12fc",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "387bc1d6-9cd3-4bdc-9e53-fd70124c81c4",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "472d0938-0368-46ab-a14b-84ba339652ad",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "151b1ca7-7324-4363-b324-f4c1d420cd47",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "f14d4edf-5493-433f-a40e-c20d35757c43",
    name: {
      ar: "شقة STD",
      ru: "Квартира STD",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا تو دي غريسوغونو",
      ru: "Safa Two de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "cf253ef4-af77-4474-87ee-f63a23449e9e",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "18780519-180a-412b-8019-bd512cc37ac5",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "2107cc9c-9622-4e20-be65-85aee772be89",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "ea9f7aaf-07fd-4e80-85af-77dfbf8dca2a",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك سوبيربيا",
      ru: "DAMAC Suburbia",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
  },
  {
    id: "8de60e4a-89c0-46b5-ad52-ecaa35f8108d",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "ذا كريسنت",
      ru: "The Crescent",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
  {
    id: "08200ba5-1a98-4811-b092-6bf4d07b7a46",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك ريفرسايد فيوز",
      ru: "Вид на реку DAMAC",
    },
    location: {
      ar: "داماك ريفرسايد كوميونتي",
      ru: "DAMAC Riverside Community",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "ad691688-a480-48ad-abf0-b51682196212",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيلو 3",
      ru: "ELO 3",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "be62c749-5dca-4a6c-8944-63278778861d",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك ريفرسايد فيوز",
      ru: "Вид на реку DAMAC",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مجمع دبي للاستثمار",
      ru: "Дубайский инвестиционный парк",
    },
  },
  {
    id: "a7ea5af4-ea78-4a97-898f-bc512cfb1bb0",
    name: {
      ar: "4 فيلا",
      ru: "4 Вилла",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "فيولت 4",
      ru: "Violet 4",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "01d93ff5-d987-42d3-92ce-c58d35b6fc7e",
    name: {
      ar: "7 فيلا",
      ru: "7 Вилла",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "يوتوبيا",
      ru: "утопия",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "5b46e6ed-c7fe-424e-8610-536df8470b83",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيلو 2",
      ru: "ELO 2",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "94af419a-80c7-490a-9385-97e7fc0b8cc0",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيفرغرينز",
      ru: "Evergreens",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "1c80aadf-dddc-40cb-912c-540b0ed868dc",
    name: {
      ar: "7 فيلا",
      ru: "7 Вилла",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "مجموعة أوتوغراف",
      ru: "Autograph Collection",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "62c0d374-4dbf-436d-814b-c7a4feecef01",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "إيلو",
      ru: "ELO",
    },
    location: {
      ar: "داماك هيلز 2",
      ru: "ДАМАК ХИЛЛС 2",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b34ee7c3-5dcd-41fd-bcf4-31da08eb1124",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "5949e775-56d8-4e92-8df5-93b69dc8c55c",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f9b3faba-5499-4450-87d0-1741137cf0d1",
    name: {
      ar: "5 شقق",
      ru: "5 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كوتور بتوقيع كافالي",
      ru: "Couture by Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "071b37d5-7c5c-4b90-9e22-88522c3bb922",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "ألتيتيود دي جريسوغونو",
      ru: "Altitude de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "b5f8bb1f-6260-4187-a809-e64a615e5643",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "ألتيتيود دي جريسوغونو",
      ru: "Altitude de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "f122f1fb-1c2d-48e5-bb57-d149b4925cb1",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a30d4cbd-5d6b-4389-a6a8-724f66ab4c68",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "لاجون فيوز",
      ru: "Lagoon Views",
    },
    location: {
      ar: "داماك لاجونز",
      ru: "DAMAC Lagoons",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d82e96bf-cd83-4769-b213-d5e4495b9e0f",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف جيت 2",
      ru: "Golf Gate 2",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "ad17dca0-149f-49d2-bd13-7a00d372db41",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "9ec080ac-c981-405f-b164-a88bdcb9eb9b",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "1cb198c8-d0fa-4a7d-a9d2-1be236330050",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "87fcaf7e-6252-4d0b-a965-244679996aa8",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك كازا",
      ru: "DAMAC Casa",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "الصفوح",
      ru: "Аль Суфух",
    },
  },
  {
    id: "e1ba8cb3-9b92-4ae3-a2ed-aa4e99cd110a",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "وقت",
      ru: "VOLTA",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "0094eeb6-d6b6-4afe-ad91-276d6c1d0a47",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "وقت",
      ru: "VOLTA",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "74e8fcf9-1cb6-496c-a597-14a2d4430c9c",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "وقت",
      ru: "VOLTA",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "510859a9-cfb5-45de-a34f-f26e10e2082f",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "d79b8219-41ff-4732-8682-2599b730a84f",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "b1cb3aaf-65ce-4b94-9d42-2b4e7ee17d28",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "غولف غرينز",
      ru: "GOLF GREENS",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "f9cef9f4-6248-4303-997d-03e6e36b2884",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "cdc78749-0c13-4517-bb3e-feb185fde65e",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال كراون",
      ru: "Canal Crown",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "440abff8-8ab5-41a1-9490-fc24e94750e0",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "bf629e97-7ef0-4838-a017-d0a64c5a97fc",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "1d49ce76-fb1a-4728-a7bf-075a439c915c",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس",
      ru: "CANAL HEIGHTS",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "3046835f-63cd-4f1e-8f22-2ef5bea62785",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "712daada-fe1f-463c-a008-a3bef87a3145",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي 2 بتوقيع كافالي",
      ru: "DAMAC Bay 2 от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "994dec1e-023f-4028-abed-ee29fbe34b8c",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "هاربر لايتس دي جريسوغونو",
      ru: "HARBOUR LIGHTS DE GRISOGONO GENEVE",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي الملاحية",
      ru: "Дубайский морской город",
    },
  },
  {
    id: "df874cce-b4da-4c6c-ad9e-6ee485901d53",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "acac1179-d907-42dd-aafc-860ca0c5363c",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "3e0ddd9c-5688-4ec7-a81a-34a6e248eb54",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "كانال هايتس 2 دي جريسوغونو",
      ru: "ДЕ ГРИСОГОНО ХАЙТС 2 КАНАЛ",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "a8e9cbfc-4814-4467-b244-ed7e5d427568",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "7fd690f8-ef5f-468f-beea-c7107bdb1b01",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك باي بتوقيع كافالي",
      ru: "DAMAC Bay от Cavalli",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "ميناء دبي",
      ru: "Дубайская гавань",
    },
  },
  {
    id: "42262823-6a67-4297-b90a-a0ef97ae0793",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا تو دي غريسوغونو - البرج B",
      ru: "Safa Two de GRISOGONO - Tower B",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "bdd51d79-d04c-468f-8c25-2f3b79689f90",
    name: {
      ar: "شقة STD",
      ru: "Квартира STD",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا تو دي غريسوغونو",
      ru: "Safa Two de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "c2aefa15-253a-45bf-ae37-16a01f3212b9",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "23e1cbf4-8feb-4b7d-b9a3-303fb6a86249",
    name: {
      ar: "3 شقق",
      ru: "3 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "17e8c8a4-0271-4c41-bcdc-4316a41f4b2d",
    name: {
      ar: "4 شقق",
      ru: "4 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "صفا ون دي غريسوغونو",
      ru: "Safa One de GRISOGONO",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "شارع الشيخ زايد",
      ru: "Шоссе шейха Зайда",
    },
  },
  {
    id: "31c93d04-c496-4c3b-82ea-96fe57fbf2c3",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "بارك تاون في داماك هيلز",
      ru: "Парк Таун в DAMAC Hills",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "3bcfc177-6167-4c23-b75f-197dd00f43cc",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "بارك تاون في داماك هيلز",
      ru: "Парк Таун в DAMAC Hills",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "a9c1bc5b-11ff-499b-84ed-76c7e41dbac6",
    name: {
      ar: "شقة STD",
      ru: "Квартира STD",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "بارك تاون في داماك هيلز",
      ru: "Парк Таун в DAMAC Hills",
    },
    location: {
      ar: "داماك هيلز",
      ru: "Холмы ДАМАК",
    },
    area: {
      ar: "دبي لاند",
      ru: "Дубайленд",
    },
  },
  {
    id: "4ed42c5d-0bc9-45de-a192-e911a29eaabf",
    name: {
      ar: "شقة واحدة",
      ru: "1 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك ماجستين",
      ru: "DAMAC Majestine",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "fc6109c4-6424-4c5d-9898-d38d24b6fe0f",
    name: {
      ar: "شقة STD",
      ru: "Квартира STD",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك ماجستين",
      ru: "DAMAC Majestine",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "خليج الأعمال",
      ru: "Бизнес-Бэй",
    },
  },
  {
    id: "146bb761-5e6e-44d4-b33f-74167e85db54",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "داماك سوبيربيا",
      ru: "DAMAC Suburbia",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "جبل علي",
      ru: "Джебель Али",
    },
  },
  {
    id: "5e9c3b68-18f6-4304-9871-aca0833b6566",
    name: {
      ar: "2 شقة",
      ru: "2 Квартира",
    },
    country: {
      ar: "الإمارات",
      ru: "Объединенные Арабские Эмираты",
    },
    city: {
      ar: "دبي",
      ru: "Дубай",
    },
    project: {
      ar: "ذا كريسنت",
      ru: "The Crescent",
    },
    location: {
      ar: "",
      ru: "",
    },
    area: {
      ar: "مدينة دبي للإنتاج",
      ru: "Дубай Продакшн Сити",
    },
  },
];
